export default {
  domainDirectory: {
    title: "공식 도메인", subtitle: "여기에서 공식 주소를 확인하세요. 탭하면 복사됩니다.", available: "개 연결 가능",
    loading: "도메인 불러오는 중…", loadFailed: "도메인을 불러오지 못했습니다", retry: "다시 불러오기", empty: "활성 도메인이 없습니다",
    tapToCopy: "탭하여 복사", checking: "확인 중", checkingShort: "확인 중", online: "연결 가능", offline: "연결 시간 초과",
    waiting: "확인 대기", timeout: "시간 초과", testAll: "모든 도메인 지금 테스트", updatedEveryFifteenSeconds: "연결 상태를 15초마다 자동 확인합니다",
    saveReminder: "도메인 정보를 보관하려면 이 페이지를 스크린샷으로 저장하세요", copied: "도메인이 복사되었습니다",
    names: { primary: "주 도메인", chinaAccel: "중국 가속", secondary: "보조 도메인" },
  },
  nickname: {"edit": "닉네임 수정", "hint": "2–20자의 한글/영문, 숫자 또는 _", "saved": "닉네임이 저장되었습니다", "taken": "이미 사용 중인 닉네임입니다", "invalid": "2–20자의 한글/영문, 숫자 또는 _만 사용하세요. 공식 예약 이름은 사용할 수 없습니다.", "failed": "저장에 실패했습니다. 다시 시도해 주세요."},
  common: {
    confirm: "확인",
    cancel: "취소",
    search: "검색",
    language: "언어",
    pleaseRelogin: "로그인이 만료되었습니다. 다시 로그인해 주세요",
    switched: "전환됨",
    currentLanguage: "현재 언어",
    selectLanguage: "언어 선택",
    loading: "로딩 중...",
    loadingMore: "더 불러오는 중...",
    noMoreData: "더 이상 데이터가 없습니다",
    noData: "데이터 없음",
    serverUnavailable: "서버를 일시적으로 사용할 수 없습니다",
    loadFailed: "로드 실패",
    requestFailed: "요청 실패",
    retry: "다시 시도",
    projectName: "PANTA MARKET",
    duplicateSubmission: "중복 제출하지 마십시오",
    fee: "수수료",
    submit: "제출",
    tip: "안내",
    connecting: "연결 중...",
    connectWalletFirst: "먼저 지갑을 연결해 주세요",
    connect: "연결",
    insufficientBalance: "잔액 부족",
    developing: "기능 개발 중",
    copyFailed: "복사 실패",
    sessionAuthRelogin: "다시 로그인",
    sessionAuthStay: "유지",
    pager: {
      prevPage: "이전",
      nextPage: "다음",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "이동",
      jumpConfirm: "확인",
    },
  },
  tabbar: {
    home: "홈",
    market: "타임라인",
    timeline: "타임라인",
    prediction: "AI 이벤트 계약 예측",
    createMarket: "마켓 생성",
    planet: "플래닛",
    trade: "거래",
    finance: "금융",
    fund: "펀드",
    assets: "자산",
    planethistory: "기록"
  },
  tradeMenu: {
    contract: "이벤트 계약",
    insurance: "보험",
    spot: "현물",
    flash: "플래시 스왑"
  },
  home: {
    searchPlaceholder: "BTC",
    categoryAll: "전체",
    categoryCrypto: "암호화폐",
    categoryEquity: "주식",
    categoryCommodity: "원자재",
    categoryForex: "외환",
    categoryMetal: "귀금속",
    predictionLabel: "예측",
    rise: "상승",
    fall: "하락",
    bannerTitle: "PANTA MARKET",
    bannerSubtitle: "AI 예측 · 이벤트 계약 · 스마트 분석",
    predictionCategories: {
      hot: "타임라인",
      sports: "스포츠",
      world: "세계",
      politics: "정치",
      economy: "경제"
    },
    predictionSubCategories: {
      crypto: "현물",
      forex: "외환",
      commodities: "상품"
    },
    features: {
      recharge: "충전",
      rechargeDesc: "빠른 충전",
      contract: "이벤트 계약",
      contractDesc: "혁신적인 금융 상품",
      predict: "AI 예측",
      fund: "PANTA MARKET Treasury",
      invite: "친구 초대",
      global: "글로벌 노드"
    },
    insurance: {
      title: "계약 보험 풀(TAKER)",
      aiPoolTitle: "AI 보험 풀",
      ordinaryPoolTitle: "일반 보험 가치 풀",
      approxUsdt: "≈ {amount} U",
      approxPantaRef: "≈ {amount} PANTA (참고)",
      more: "자세히 보기",
      yesterday: "어제 추가",
      service: "스마트 서비스"
    },
    market: {
      tabs: {
        main: "주요 코인",
        hot: "인기 목록",
        rise: "상승률 목록",
        price: "가격 목록"
      },
      headers: {
        pair: "거래 쌍",
        latest: "최신 가격",
        change: "24시간 변동률"
      },
      viewMore: "더 보기",
      collapse: "접기"
    },
    announcement: {
      title: "공지",
      heading: "공지",
      text: "PANTA MARKET에 오신 것을 환영합니다. 여기에서 PANTA MARKET가 만든 독창적인 AI 및 예측 보험 시스템을 경험하고 WEB3 예측 시장에 쉽게 참여하여 부의 여정을 시작할 수 있습니다.",
      time: "2025/11/19 10:00",
      gotIt: "확인했습니다",
      viewDetail: "자세히 보기",
      systemLabel: "시스템 공지"
    },
    timePeriods: {
      "1min": "1분",
      "30min": "30분",
      "1hour": "1시간"
    },
    footer: {
      australia: "· 호주",
      uae: "· 아랍에미리트",
      attention: "· 주의:",
      attentionText: "PANTA MARKET은 자체 운영되는 AI 기반 WEB3 예측 시장 회사입니다. 우리는 어떤 형태나 이름으로든 제3자로부터 수수료를 징수하는 것을 승인하지 않습니다. 문의 사항은 공식 고객 서비스({email})로 문의하십시오."
    },
    timeframes: {
      "1s": "1분",
      "1m": "1분",
      "5m": "5분",
      "15m": "15분",
      "1h": "1시간",
      "4h": "4시간",
      "1d": "1일"
    },
    statusHotEn: "HOT",
    yes: "예",
    no: "아니오",
    hotBannerTitle: "이벤트 계약",
    homeBanner: {
      s1t1: "AI 기반",
      s1t2: "AstralX 핵심 생태계",
      s1cta: "AstralX",
      s2t: "Galaxy 펀드",
      s2s1: "원금 보호 안내",
      s2s2: "및 수익 지급 규칙",
      s2cta: "구독하기",
      s3s: "가격 예측",
      s3cta: "예측하기",
    },
    catCrypto: "암호화폐",
    catMetal: "금속",
    catSports: "스포츠",
    catPolitics: "정치",
    catEntertainment: "엔터",
    statusHot: "인기",
    statusLocked: "잠김",
    statusLive: "진행 중",
    statusLockedWait: "잠김, 정산 대기",
    jouleUnit: "JOULE",
    nowLabel: "지금",
    endAtFallback: "--",
    viewMoreOptions: "{n}개 옵션 더 보기"
  },
  withdraw: {
    title: "출금",
    headerTitle: "출금",
    address: "출금 주소",
    addressLabel: "출금 주소",
    addressPlaceholder: "주소를 입력하거나 붙여넣으세요",
    network: "네트워크",
    selectNetwork: "네트워크 선택",
    networkHint: "출금 주소가 선택한 네트워크와 일치하는지 확인하세요",
    withdrawAmount: "출금 금액",
    receiveAmount: "수령 금액",
    networkFee: "네트워크 수수료",
    submit: "출금 확인",
    submitButton: "출금",
    balance: "잔액:",
    all: "전체",
    amountPlaceholder: "입력하세요",
    minimumWithdrawal: "최소 출금 수량: {amount} USDT",
    fee: "수수료",
    confirm: "확인",
    confirmTitle: "작업 확인",
    confirmContent: "이 작업을 계속 진행하시겠습니까?",
    toasts: {
      fetchFailed: "자산 조회 실패",
      enterAddress: "출금 주소를 입력하세요",
      enterValidAmount: "유효한 출금 수량을 입력하세요",
      insufficientBalance: "잔액 부족",
      minimumAmount: "최소 출금 수량은 {amount} USDT입니다",
      processing: "처리 중...",
      success: "출금 성공!",
      requestSuccess: "출금 신청 성공",
      requestFailed: "출금 실패, 다시 시도해 주세요",
      notConfigured: "아직 출금할 수 없습니다"
    },
    addressHint: "출금은 지갑 주소로 전송됩니다"
  },
  deposit: {
    headerTitle: "입금",
    connectPrompt: "입금하려면 먼저 지갑을 연결해주세요",
    loading: "로딩 중...",
    depositAddress: "입금 주소",
    address: "주소",
    depositTAKER: "TAKER 입금",
    generating: "생성 중...",
    minimumDeposit: "*최소 입금액 10.0000 USDT",
    depositAmount: "입금 금액",
    balance: "잔액",
    amaBalance: "TAKER 잔액",
    amount: "금액",
    amountPlaceholder: "입금 수량을 입력하세요",
    minimumNotice: "*최소 {min} {token}",
    processing: "처리 중...",
    confirm: "입금 확인",
    confirmTitle: "작업 확인",
    confirmContent: "이 작업을 계속 진행하시겠습니까?",
    helpText: "입금은 스마트 계약의 recharge 메서드를 호출하며, TAKER 토큰 승인이 필요합니다",
    toasts: {
      copySuccess: "복사 성공",
      dataLoadFailed: "데이터 로드 실패",
      enterValidAmount: "유효한 입금 수량을 입력하세요",
      invalidAmount: "입금 금액은 {min} TAKER 이상이어야 합니다",
      invalidAddress: "잘못된 입금 주소",
      checkingAllowance: "한도 확인 중...",
      approving: "승인 중...",
      approveSuccess: "승인 성공",
      depositing: "입금 중...",
      depositSuccess: "입금 성공",
      depositFailed: "입금 실패",
      balanceLoadFailed: "지갑 테스트 USDT 잔액을 읽지 못했습니다. 새로고침 후 다시 시도하세요",
      contractError: "계약 호출 실패, 잔액을 확인하세요",
      userCancelled: "작업을 취소했습니다",
      insufficientFunds: "잔액 부족",
      wrongNetwork: "올바른 네트워크로 전환하세요",
      requestingAuth: "지갑 승인 요청 중...",
      waitingConfirmation: "거래 확인 대기 중...",
      transactionFailed: "거래 시작 실패",
      transactionCancelled: "거래를 취소했습니다",
      genericError: "거래 실패",
      configNotReady: "아직 입금할 수 없습니다",
      invalidTxHash: "유효한 트랜잭션 해시를 입력하세요",
      claimPending: "입금 제출됨, 입금 대기 중",
      cannotGetBalance: "잔액을 가져올 수 없습니다. 새로고침 후 다시 시도하세요"
    },
    depositNotice: "아래 주소로 이체하세요. 도착 후 시스템이 자동 처리합니다",
    usdtBalance: "USDT 잔액"
  },
  team: {
    headerTitle: "내 팀",
    contractEarnings: "내 계약 수익",
    btcFund: "재테크 수익",
    stats: {
      personalEarnings: "개인 누적 수익",
      teamEarnings: "팀 수익",
      personalVolume: "개인 거래량",
      teamVolume: "팀 거래량",
      personalPower: "개인 연산력",
      teamTotalPower: "팀 총 연산력",
      periodPersonal: "개인 거래량",
      periodTeam: "팀 수익",
      totalTeam: "팀 거래량",
      personalSubscribed: "개인 스테이킹량",
      teamSubscribed: "팀 스테이킹량"
    },
    unclassifiedHint: "과거 지급 출처 확인 필요: {amount} {asset}",
    links: {
      invite: "친구 초대",
      details: "팀 세부 정보"
    },
    inviteBannerTitle: "친구 초대로 팀 커미션 잠금 해제",
    inviteBannerSubtitle: "팀 커미션을 잠금 해제하세요",
    inviteBannerCta: "지금 참여"
  },
  finance: {
    title: "금융 페이지는 개발 중입니다..."
  },
  wealthAccess: {
    exchangeThresholdFailed: "교환 실패: 조건을 충족하지 않았습니다",
    internalPrice: "내부 가격",
    marketPrice: "시장 가격",
    coinBasis: "코인 기준",
    legacyBasis: "코인 기준",
    contractBasis: "정산 기준",
    unitPrice: "매수 단가",
    quotaUsed: "내부 가격 누적 매수",
    quotaRemaining: "내부 가격 잔여 한도",
    quotaHint: "모든 상품 합산 평생 {limit} PANTA 한도입니다. 내부 가격 종료, 만기 또는 VIP 변경으로 초기화되지 않습니다.",
    principal: "원금",
    principalReturn: "만기 반환 원금",
    dailyYield: "일일 총수익",
    coinYieldHint: "일일 총수익 = PANTA 원금 × 연이율 ÷ 360 (최소 단위 내림). 가격 변동은 계약 수량에 영향을 주지 않습니다. 배분은 적용 규칙을 따릅니다.",
    legacyHint: "코인 기준 계약입니다. PANTA 원금 상환은 계약상 만기 가격으로 환산됩니다.",
    quotaError: "내부 가격 잔여 한도를 초과했습니다. 수량을 줄이세요. 주문 자동 분할이나 시장 가격 전환은 하지 않습니다.",
    permissionChanged: "현재 VIP로는 이 상품을 매수할 수 없습니다. 목록을 갱신했습니다.",
    quoteChanged: "가격 또는 자격이 변경되었습니다. 새 견적을 확인한 후 다시 확정하세요.",
    quoteExpired: "견적이 만료되었습니다. 갱신 후 확인하세요.",
    retryQuote: "견적 갱신",
    stakeGateTitle: "PANTA 매도 스테이킹 요건",
    stakeGateBody: "VIP{vip}: 유효 스테이킹 {staked} PANTA, 필요 {required} PANTA, 부족 {shortfall} PANTA. 매도만 제한되며 매수에는 영향이 없습니다.",
    goStake: "스테이킹으로",
    refreshEligibility: "자격 갱신",
  },
  fundPage: {
    heroTitle: "매일 PANTA 수익 지급",
    heroDesc: "Galaxy 펀드 청약으로 연환산 수익 확보",
    learnMore: "자세히 보기",
    allProducts: "전체 상품",
    subscribe: "청약",
    stake: "스테이킹",
    stakePreview: "스테이킹 미리보기",
    searchCoin: "코인 검색",
    allPeriods: "전체 기간",
    colCoin: "펀드명",
    colApy: "코인 기준 연환산",
    colTerm: "기간",
    fixedTerm: "정기",
    galaxyProduct: "Galaxy {n}호",
    termLabel: "기간",
    apyLabel: "연환산",
    stakeCap: "개인 보유량",
    stakeAmount: "스테이킹 금액",
    estEarnings: "예상 수익",
    stakeDisclaimer: "수익은 참고용이며 보장이 아닙니다. 입금분 약 70%는 가용 잔액, 30%는 체험금으로 배분되며, 체험금은 약 3배 거래량 달성 후 해제됩니다.",
    stakeSuccess: "스테이킹 성공. 보상은 T+1 00:00:00부터 시작됩니다!",
    annualized: "참고 연환산",
    perShareYield: "만 좌 수익(WBS)",
    dayUnit: "일",
    empty: "펀드 상품이 없습니다",
    loadFailed: "불러오기 실패",
    rulesTitle: "펀드 안내",
    gotIt: "확인",
    pantaAvailable: "PANTA 가용",
    activeFaceValue: "운용 좌수",
    totalReward: "펀드 누적 수익(PANTA)",
    fundYieldUnavailable: "--/서비스 업데이트 필요",
    effectiveVip: "유효 등급",
    myHoldings: "펀드 구매 기록",
    faceValue: "가치",
    maturity: "만기",
    stakeStart: "스테이킹 시간",
    pantaPrice: "PANTA 단가",
    noMoreHoldings: "더 이상 보유 내역이 없습니다",
    subscriptionStatus: {
      ACTIVE: "진행 중",
      SETTLED: "정산 완료",
      CANCELLED: "취소됨",
      MANUAL_REVIEW: "수동 검토",
    },
    minPanta: "최소 청약 PANTA",
    pantaAmount: "청약 수량(PANTA)",
    stepHint: "{step}의 정수배, 최소 {min}",
    getQuote: "견적 받기",
    confirmStake: "스테이킹 확인",
    jouleDebit: "JOULE 차감",
    expectedPanta: "스테이킹 PANTA",
    quoteExpires: "견적 유효 기한",
    unavailable: "아직 이용 불가",
    invalidAmount: "유효한 PANTA 단계 수량을 입력하세요",
    quoteFailed: "견적 실패",
    rewards: "펀드 보상",
    unlock: "PANTA 동결 배치",
    unlockProgress: "사용된 거래량",
    pantaLedger: "PANTA 원장"
  },
  finanfund: {
    title: "TAKER 재무 기금",
    subtitle: "간단하고 효율적으로 쉽게 수익 창출",
    productName: "TAKER 재무 기금",
    minAmount: "최소 금액",
    incomeRatio: "수익률",
    lockPeriod: "락업 기간",
    dailyReturn: "일일 수익",
    earning: "획득",
    redemptionRules: "상환 규칙",
    rules: {
      rule1: "TAKER 재무 기금은 위탁 후 상환할 수 없습니다",
      rule2: "일일 수익은 자동으로 입금됩니다",
      rule3: "락업 금액은 락업 기간 종료 후 반환됩니다"
    },
    subscription: "구독",
    amountPlaceholder: "금액 입력",
    balance: "잔액",
    availableFunds: "사용 가능 자금",
    all: "전체",
    subscribeButton: "구독",
    toasts: {
      productIdNotExist: "상품 ID가 존재하지 않습니다",
      enterValidAmount: "유효한 구독 금액을 입력하세요",
      minAmountRequired: "구독 금액은 {amount} USDT 이상이어야 합니다",
      subscribeSuccess: "구독 성공",
      subscribeFailed: "구독 실패"
    }
  },
  my: {
    headerTitle: "내 정보",
    login: "탭하여 로그인",
    inviteCode: "초대 코드:",
    groups: {
      common: "일반 기능",
      trading: "거래",
      finance: "금융",
      help: "도움말"
    },
    features: {
      invite: "친구 초대",
      team: "내 팀",
      insurance: "이벤트 계약 보험",
      contract: "이벤트 계약",
      exchange: "환전",
      fund: "AI 재무 기금",
      communitySquare: "커뮤니티 광장",
      createEvent: "이벤트 생성",
      community: "공식 커뮤니티",
      terms: "서비스 약관",
      announcement: "공지",
      privacy: "개인정보 보호정책",
      aboutUs: "회사 소개"
    }
  },
  community: {
    title: "공식 커뮤니티",
    bannerTitle1: "커뮤니티 참여",
    bannerTitle2: "글로벌 사용자와 소통",
    linkCopied: "링크가 복사되었습니다"
  },
  invite: {
    headerTitle: "친구 초대",
    rulesEntry: "초대 규칙",
    subtitle: "팀 거래마다 수익",
    mainTitle: "초대하고 수익",
    description: "링크 공유 — 친구가 거래하면 보상",
    mainTitle_old: "친구와 함께 수익",
    later: "나중에",
    modalDesc: "아직 상위가 바인딩되지 않았습니다. 초대 코드 또는 지갑 주소를 입력하면 팀 보상에 참여할 수 있습니다. 초대 링크 정보가 자동으로 채워지며, 없으면 기본 상위가 미리 입력됩니다.",
    binding: "바인딩 중…",
    bindButton: "바인딩",
    bindPlaceholder: "초대 코드 또는 지갑 주소 입력",
    bindSuperior: "상위 바인딩",
    boundLabel: "상위가 바인딩됨",
    yourCode: "초대 코드",
    shareLink: "공유 링크",
    inviteButton: "친구 초대",
    subTitle: "높은 수수료 받기",
    viewRules: "추천 규칙 보기",
    rulesLink: "추천 규칙 보기 >",
    rulesTitle: "추천 규칙",
    rules: {
      commissionTable: {
        title: "PANTA MARKET 거래량 커미션 표",
        headers: {
          level: "등급",
          personalTurnover: "개인 거래량",
          teamTurnover: "팀 거래량",
          commission: "팀 커미션"
        }
      }
    },
    inviteBoxTitle: "친구 초대",
    referralCode: "추천 코드",
    inviteLink: "초대 링크",
    loading: "로딩 중...",
    copyButton: "초대 링크 복사",
    toasts: {
      emptyContent: "내용이 비어 있습니다",
      copySuccess: "복사 성공",
      bindSuccess: "바인딩 성공",
      bindFailed: "바인딩 실패",
      alreadyBound: "상위가 이미 바인딩되어 변경할 수 없습니다",
      loginFirst: "먼저 지갑을 연결하세요",
      invalidCode: "유효한 초대 코드 또는 지갑 주소를 입력하세요",
      cannotBindSelf: "자기 자신은 바인딩할 수 없습니다"
    }
  },
  assets: {
    totalAssetsUsdt: "예상 총가치(USDT)",
    availableAssets: "가용 자산",
    noHoldings: "보유 내역 없음",
    mainSystemPanta: "메인 시스템(PANTA)",
    transferToMain: "메인 시스템으로 이체",
    tradeFrozenJoule: "거래 동결(JOULE)",
    insuranceAccountJoule: "보험 계좌(JOULE)",
    payoutPower: "연산 노드 지급",
    payoutEquity: "AI 예측 지급(JOULE)",
    mainAccount: "거래",
    insuranceAccountShort: "보험",
    copyAccountShort: "카피",
    copyAccountJoule: "카피 계정(JOULE)",
    tradingAccountHelpTitle: "거래 계정 잔액",
    copyAvailableLabel: "가용 잔액",
    copyFrozenLabel: "동결 잔액",
    copyTotalPnl: "카피 손익",
    transferSheet: {
      title: "이체",
      pairCopy: "거래/카피",
      pairInsurance: "거래/보험",
      tradingAccount: "거래 계좌",
      copyAccount: "카피 계좌",
      insuranceAccount: "보험 계좌",
      jouleHint: "JOULE만 이체 가능",
      submit: "제출",
      transferring: "이체 중...",
      success: "이체 성공",
      failed: "이체 실패, 다시 시도하세요",
    },
    computeNode: "연산 노드",
    stakedTotalPanta: "펀드 스테이킹 합계",
    stakedPlusRewardPanta: "원금+예상 수익",
    stakedPlusRewardTipTitle: "스테이킹 원금 + 예상 수익",
    stakedPlusRewardTip:
      "이 수치는 스테이킹 원금과 예상 총수익의 합입니다.",
    stakedPrincipalLabel: "스테이킹 원금",
    stakedExpectedYieldLabel: "예상 수익",
    annualEarningsPanta: "펀드 누적 수익",
    frozenTotalPanta: "동결 합계",
    unlockedTotalPanta: "누적 해제",
    fundTeamPendingPanta: "펀드 팀 미지급 수익(PANTA)",
    fundTeamPaidPanta: "펀드 팀 지급 수익(PANTA)",
    pendingRewardPanta: "에어드롭 대기",
    paidRewardPanta: "에어드롭 완료",
    expectedAirdropQuota: "예상 에어드롭 금액",
    cumulativeAirdropValue: "누적 에어드롭 가치: {value} USDT",
    roundExpectedValue: "이번 라운드 예상 가치: {value} USDT",
    historyTotalValue: "누적 총가치: {value} USDT",
    nextAirdropAt: "다음 지급 시간: {time}",
    airdropEstimateUnavailable: "추정 불가",
    roundExpectedValueUnavailable: "이번 라운드 예상 가치: 추정 불가",
    airdropEstimateHint: "예상치이며 실제 정산 기준",
    roundProgress: "노드 생성 진행률",
    currentNodeCount: "현재 노드 수",
    deductedNodeCount: "차감 노드 수",
    invalidNodeCount: "무효 노드 수",
    todayRelease: "오늘 해제",
    releaseFrozenPanta: "해제 동결",
    unlockQuota: "해제 한도",
    unlockQuotaNote: "오늘 해제 가능 한도 0.0000",
    tradeNode: "거래 노드",
    tradeNodeDesc: "구매 후 VIP3로 바로 업그레이드, 전용 거래 혜택 해제",
    tradeNodeHint: "노드 구매는 자격만 부여되며, 가격은 견적 기준",
    buyNode: "노드 구매",
    buyNodeModal: {
      title: "거래 노드 구매",
      description: "{amount}JOULE 결제 시 거래 노드 자격 획득",
      quotePreview: "{name} · {amount} JOULE · 잔여 {remaining}",
      afterBalance: "구매 후 잔액 약 {amount} JOULE",
      pickProduct: "노드 상품 선택",
      availableBalance: "현재 가용 잔액",
      cancel: "구매 취소",
      confirm: "구매 확인",
      purchasing: "구매 중...",
      success: "구매 성공",
      failed: "구매 실패, 다시 시도하세요",
      insufficient: "잔액 부족, 먼저 입금하세요",
      unavailable: "아직 이용 불가"
    },
    tradingAccountRecords: "거래 내역",
    wealthAccountRecords: "펀드 내역",
    insuranceAccountRecordsShort: "보험 계좌 기록",
    detailTitle: "자산 상세",
    jouleConvert: "JOULE 환산(×환율)",
    usdtPart: "USDT 부분",
    jouleAvailable: "JOULE 가용",
    tradeFrozen: "거래 동결(JOULE)",
    financeReleaseFrozen: "재테크 해제 동결(JOULE)",
    insuranceFrozen: "보험 동결 한도(JOULE)",
    usdtAvailableLabel: "USDT 가용",
    usdtFrozenLabel: "USDT 동결",
    totalSum: "합계",
    available: "가용",
    deposit: "입금",
    withdraw: "출금",
    myAccountRecords: "내 계정 기록",
    nodeEquityHint: "Node equity valued in USDT, not a cash deposit",
    nodeEquityRate: "Applied rate: {rate}%",
    nodeEquitySources: {
      PERSONAL: "Personal insurance equity",
      TEAM: "Team insurance equity",
      ADMIN: "Platform Airdrop",
      AI_INSURANCE: "AI insurance node equity payout",
      BACKFILL: "AI insurance node equity backfill",
      OTHER: "Node equity credited",
    },
    recordTypes: {
      NODE_EQUITY_CREDIT: "Node equity credited",
      BET_STAKE: "베팅 동결",
      WIN_PAYOUT: "거래 수익",
      LOSS_SETTLEMENT: "거래 손실",
      REFUND: "환불",
      INSURANCE_PREMIUM: "보험료 지출",
      INSURANCE_PAYOUT: "보험 지급",
      INSURANCE_TRANSFER_IN: "보험 입금",
      INSURANCE_TRANSFER_OUT: "보험 출금",
      NETWORK_DIFFERENTIAL: "거래 차등 보상",
      NETWORK_PEER: "거래 동급 보상",
      NETWORK_UNLOCK: "수익 해제",
      EVENT_INSURANCE_PAYOUT: "연산 노드 지급",
      EVENT_INSURANCE_PEER: "연산 동급 보상",
      TRANSFER_IN: "입금",
      TRANSFER_OUT: "출금",
      PREMIUM_LOCK: "보험료 잠금",
      PREMIUM_SETTLE: "보험료 지출",
      PREMIUM_REFUND: "보험료 환급",
      WEALTH_SUBSCRIPTION: "펀드 청약",
      SUBSCRIPTION_LOCK: "스테이킹 잠금",
      WEALTH_DAILY_REWARD: "펀드 일일 이자",
      WEALTH_TEAM_REWARD: "펀드 팀 보상",
      MATURITY_RELEASE: "만기 원금 반환",
      WEALTH_UNLOCK: "수익 해제",
      COPY_SHARE_HOLD: "카피 분배 동결",
      COPY_SHARE_RELEASE: "카피 분배 동결 해제 / 반환",
      COPY_SHARE_PAYOUT: "카피 분배 지출",
      COPY_TRADE_TRANSFER_OUT: "카피 계좌로 이체",
      COPY_TRADE_TRANSFER_IN: "카피 계좌에서 입금",
      COPY_WIN_PAYOUT: "카피 수익",
      COPY_LOSS_SETTLEMENT: "카피 손실",
      COPY_TRANSFER_IN: "카피 계좌 입금",
      COPY_TRANSFER_OUT: "카피 계좌 출금",
      COPY_SHARE_PAYOUT_IN: "카피 분배 입금",
      COPY_SHARE_POOL_IN: "카피 분배 풀 입금",
      COPY_SHARE_POOL_REFUND: "카피 분배 풀 환급",
      COPY_SHARE_POOL_MIGRATION: "카피 분배 풀 이전",
      COPY_FLOW: "카피 거래 내역",
    },
    recordCategories: {
      NODE_EQUITY: "Node equity",
      TRADE_PNL: "거래 손익",
      PREMIUM: "보험료",
      INSURANCE_PAYOUT: "보험 지급",
      TEAM_REWARD: "팀 보상",
      COPY: "카피 내역",
      COPY_TRADE_PNL: "카피 손익",
      COPY_SHARE: "카피 분배",
      COPY_TRANSFER: "카피 이체",
      WEALTH_REWARD: "펀드 일일 이자",
      UNLOCK: "수익 해제",
      PRINCIPAL: "청약/원금 반환",
      TRANSFER: "내부 이체"
    },
    amountPendingReview: "금액 확인 필요",
    creditedSplit: "가용 {available} · 동결 {frozen}",
    creditedSplitPending: "분할 확인 필요",
    afterBalance: "변동 후 가용 {available} · 동결 {frozen}",
    unlockHint: "동결 → 가용 (신규 수익 아님)",
    transferFromInsurance: "보험 계좌",
    transferFromMain: "주 계좌",
    all: "전체",
    transfer: "이체",
    insuranceDeduction: "보험 공제",
    insurancePayout: "보험 지급",
    noRecords: "기록 없음",
    availableChange: "가용 {amount}",
    frozenChange: "동결 {amount}",
    frozenOp: "동결 {amount} {token}",
    lockedOp: "잠금 {amount} {token}",
    detail: {
      sessionId: "세션 ID",
      networkReward: "팀 보상 상세",
      insuranceClaim: "AI 지급 상세",
      creditStatus: "입금 상태",
      creditedPendingHint: "입금 완료, 처리 확인 재시도 중",
      orderId: "출처 주문",
      source: "출처"
    },
    actions: {
      deposit: "입금",
      withdraw: "출금",
      exchange: "환전",
      transfer: "이체"
    },
    loginPrompt: {
      text: "먼저 지갑을 연결해주세요",
      button: "연결하기"
    },
    toasts: {
      connectFailed: "연결에 실패했습니다. 다시 시도해주세요"
    },
    jouleUsdtRate: "1 JOULE = {rate} USDT",
    pantaUsdtRate: "1 PANTA = {price} USDT",
  },
  wallet: {
    title: "내 지갑",
    address: "지갑 주소",
    addressCopied: "주소가 복사되었습니다",
    inviteCode: "초대 코드",
    logout: "로그아웃",
    login: "로그인",
    toasts: {
      networkSwitchCancelled: "사용자가 네트워크 전환을 취소했습니다",
      networkConfigNotFound: "네트워크 구성을 찾을 수 없습니다 {chainId}",
      signatureCancelled: "사용자가 서명을 취소했습니다",
      connectionFailed: "지갑 연결에 실패했습니다",
      accountSwitched: "지갑 계정이 변경되었습니다. 다시 연결해주세요",
      connectionTimedOut: "연결 시간이 초과되었습니다. 다시 시도해주세요",
      loginSuccess: "로그인 성공",
      logoutSuccess: "로그아웃 성공",
      switchNetwork: "입금을 시도하기 전에 지갑에서 {chainName}로 전환해주세요",
      wrongChain: "지원되지 않는 네트워크입니다. {chainName}로 전환해주세요",
      switchingNetwork: "네트워크 전환 중...",
      switchNetworkFailed: "네트워크 전환에 실패했습니다. 지갑에서 수동으로 {chainName}로 전환해주세요"
    }
  },
  market: {
    title: "시장",
    banner: {
      title: "이벤트 계약",
      desc: "온체인 수익 잠재력을 실현하세요"
    },
    tabs: {
      main: "주요 코인",
      rise: "상승률 순위"
    },
    types: {
      crypto: "암호화폐",
      stocks: "미국주식",
      forex: "외환",
      commodities: "상품",
      favorites: "즐겨찾기"
    },
    headers: {
      pair: "거래쌍",
      price: "최신가",
      change: "오늘 변동률"
    },
    loading: "로딩 중...",
    loadingMore: "더 불러오는 중...",
    noMoreData: "더 이상 데이터가 없습니다"
  },
  notice: {
    loginRequired: "공지를 보려면 로그인하세요",
    empty: "공지사항이 없습니다",
    unpublished: "게시 종료",
    title: "공지사항",
    helpCenter: "도움말 센터",
    noticeDetail: "공지사항 상세",
    viewDetail: "자세히 보기",
    pdfViewer: "PDF 뷰어",
    videoPlayer: "비디오 플레이어",
    imageViewer: "이미지 뷰어",
    documentViewer: "문서 뷰어",
    clickToViewPdf: "PDF를 보려면 클릭하세요",
    clickToViewDocument: "문서를 보려면 클릭하세요",
    openInBrowser: "브라우저에서 열기",
    tryingViewer: "방법 {current}/{total} 시도 중",
    pdfLoadFailed: "PDF 미리보기 로드 실패, 다운로드하여 확인하세요",
    downloadPdf: "PDF 다운로드",
    defaultCategory: "Notice"
  },
  trade: {
    title: "이벤트 계약",
    nextRound: "다음 라운드",
    posCurrent: "현재",
    aiThenPrefix: '당시 AI: ',
    aiUnlinked: 'AI 미연결',
    aiNotRecorded: '미기록',
    insuranceLabel: "보험",
    insuranceNotSelected: '선택 안 함',
    insuranceInactive: "미적용",
    insuranceTypeNone: "미적용",
    insuranceTypeEvent: "일반 보험 가입됨",
    insuranceTypeEventShort: "일반 보험",
    insuranceTypeAi: "AI 보험 가입됨",
    insuranceTypeAiShort: "AI 보험",
    insuranceTypeConverted: "이 주문은 일반 보험으로 전환됨",
    insuranceTypeUnknown: "보험 상태 확인 필요",
    inProgress: "진행 중",
    estimatedPnl: "예상 손익",
    settlementConfirming: "정산 중, 결과 확인 중",
    balanceSyncing: "잔액 동기화 중",
    pendingReview: "확인 대기",
    connecting: "연결 중...",
    connectWallet: "연결",
    orderDetail: {
      title: "주문 상세",
      orderId: "주문 번호",
      symbol: "거래쌍",
      interval: "주기",
      direction: "실제 방향",
      aiDirection: "당시 AI",
      openTime: "개설 시간",
      settleTime: "만료 시간",
      settledAt: "정산 시간",
      openPrice: "진입가",
      closePrice: "청산가",
      stake: "원금",
      premium: "보험료",
      netProfit: "순손익",
      status: "상태",
      orderSource: "주문 출처",
      converted: "보험 전환",
      notRecorded: "미기록",
      copied: "주문 번호가 복사되었습니다",
    },
    orderStatus: {
      CREATED: "생성됨",
      ACCEPTED: "접수됨",
      CLOSED: "마감",
      FUNDS_LOCKED: "자금 잠금",
      AWAITING_SETTLEMENT: "정산 대기",
      PROCESSING: "처리 중",
    },
    insuranceBalanceInsufficient: "보험 계정 잔액 부족",
    mainBalanceInsufficient: "주 계정 잔액 부족",
    insuranceBalanceRequired: "보험 계정 잔액이 부족하여 보험을 켤 수 없습니다",
    insuranceRulesUnavailable: "보험료 규칙이 준비되지 않아 보험을 켤 수 없습니다",
    insuranceMainRequired: "주 계정 잔액이 부족하여 보험을 켤 수 없습니다",
    preferenceLoading: "보험 설정 로딩 중",
    preferenceLoadFailed: "보험 설정 로드 실패, 다시 시도하세요",
    preferenceSaveFailed: "보험 설정 저장 실패, 다시 시도하세요",
    preferenceSessionEndedSaveFailed: "라운드가 종료되어 종료 설정이 저장되지 않았습니다",
    premiumEstimate: "예상 보험료 {premium} JOULE (5-10%)",
    premiumShortfallHint: "보험 계정에 {amount} JOULE이 부족합니다",
    premiumEstimateUnavailable: "아직 보험료를 추정할 수 없습니다",
    premiumBoundEstimate: "바인딩된 전략 예상 보험료 {premium} JOULE",
    insuranceConfirmTitle: "보험료 확인",
    insuranceConfirmBody: "미리보기 보험료 {premium} JOULE. 미리보기 결과가 최종입니다. 확인 후 제출하세요.",
    actions: {
      rise: "롱",
      fall: "숏",
      buy: "매수",
      sell: "매도"
    },
    holdings: {
      current: "포지션",
      history: "거래 내역",
      currentCount: "현재 포지션 수 {n}",
      empty: "포지션 없음",
      historyEmpty: "거래 내역 없음"
    },
    position: {
      openPrice: "진입가",
      closePrice: "청산가",
      profitLoss: "손익",
      countdown: "정산까지",
      calculating: "계산 중...",
      settled: "정산 완료",
      settling: "정산 중",
      active: "활성",
      settledAt: "정산 시간"
    },
    modal: {
      amountPlaceholder: "금액을 입력하세요"
    },
    pairSelector: {
      title: "거래쌍 선택",
      searchPlaceholder: "코인 검색"
    },
    errors: {
      dataNotReady: "데이터 로딩 중, 잠시만 기다려주세요"
    },
    marketPause: {
      default: "현재 거래할 수 없습니다. 잠시 후 다시 시도해 주세요",
      lastPriceStreamWarming: "최신가 시세 준비 중입니다. 잠시 후 다시 시도해 주세요",
      marketWarming: "시장 준비 중입니다. 잠시 후 다시 시도해 주세요",
      recovering: "시세 복구 중입니다. 잠시 후 다시 시도해 주세요",
      clockNotSynced: "서버 시간이 동기화되지 않았습니다. 잠시 후 다시 시도해 주세요",
      symbolUnavailable: "해당 거래쌍은 아직 개방되지 않았습니다"
    },
    toasts: {
      connectSuccess: "연결 성공",
      connectCancelled: "연결을 취소했습니다",
      connectFailed: "연결 실패"
    },
    openPriceLabel: "시가",
    secondsUnit: "s",
    amountLabel: "금액",
  },
  exchange: {
    title: "플래시 스왑",
    from: "에서",
    to: "으로",
    balance: "잔액",
    all: "전체",
    placeholder: "입력하세요",
    fee: "수수료",
    minAmount: "최소 스왑 수량: {amount} {symbol}",
    button: "스왑",
    tradeButton: "거래",
    paymentCurrency: "지불 통화",
    estimatedGasFee: "예상 가스 수수료",
    gasPaymentNote: "GetGas 잔액으로 가스 수수료 지불",
    slippage: "슬리피지",
    auto: "자동",
    approximately: "약",
    minReceived: "최소 수령",
    exchangeRate: "환율",
    finalAmount: "최종 금액",
    confirm: "확인",
    swapSuccess: "플래시 스왑 성공!",
    swapping: "스왑 중...",
    confirmTitle: "작업 확인",
    confirmContent: "이 작업을 계속 진행하시겠습니까?",
    toasts: {
      amountStepInvalid: "환전 수량이 단계 요건에 맞지 않습니다. 조정 후 다시 시도하세요",
      quoteExpired: "견적이 만료되었습니다. 다시 확인하세요",
      fetchFailed: "자산 조회 실패",
      enterValidAmount: "유효한 금액을 입력하세요",
      minAmount: "최소 스왑 수량은 {amount} {symbol}입니다",
      swapSuccess: "스왑 성공",
      requestFailed: "요청 실패",
      insufficientBalance: "잔액 부족, 스왑할 수 없습니다",
      usdtRestricted: "USDT 심사 중, 환전 불가"
    },
    rateHint: "{usdt} USDT={joule}JOULE, no fee",
    rateHintPair: "{from} {fromSymbol} = {to} {toSymbol}",
    rateHintUsdtToJoule: "순 입금액은 견적 기준",
    rateHintJouleToUsdt: "환전 수수료 포함, 순 입금액은 견적 기준",
    rateHintPantaFree: "현재 수수료 면제, 순 입금액은 견적 기준",
    feeLabel: "수수료: {fee} {symbol}",
    feeZero: "수수료: 0 (면제)",
    grossLabel: "수수료 차감 전: {amount} {symbol}",
    netLabel: "순 입금: {amount} {symbol}",
    pantaEffectivePrice: "PANTA 적용가: {price} U",
    pantaViaUsdtHint: "USDT 환산: {price} U/PANTA · 1 U = {joulePerUsdt} JOULE",
    quoting: "견적 조회 중…",
    configFee: "Joule → USDT 수수료 {fee}",
    configLimits: "수수료 {fee} · 차감 전 가치 한도 {min}–{max} U",
    unlimited: "제한 없음",
    quoteFailed: "견적을 가져올 수 없습니다. 다시 시도하세요",
  },
  globalNode: {
    title: "글로벌 노드"
  },
  eventInsurance: {
    title: "이벤트 계약 보험",
    availableBalance: "가용 잔액",
    fundTransfer: "자금 이체",
    fundHistory: "보험 자금 기록",
    type: "유형:",
    all: "전체",
    transfer: "이체",
    fundTransferTitle: "보험 자금 이체",
    currency: "통화",
    from: "보내는 곳",
    to: "받는 곳",
    availableAccount: "가용 계좌",
    contractInsuranceAccount: "계약 보험 계좌",
    pleaseEnter: "입력하세요",
    confirmTransfer: "이체",
    insufficientBalance: "잔액 부족",
    transferSuccess: "자금 이체 성공!",
    transferFailed: "자금 이체 실패, 다시 시도하세요!",
    transferring: "자금 이체 중...",
    noRecords: "기록 없음",
    selectAccount: "계좌 선택",
    cannotTransferToSameAccount: "같은 계좌로 이체할 수 없습니다",
    cannotTransferContractAccount: "계약 계좌 이체는 지원되지 않습니다",
    contractAccount: "계약 계좌(TAKER)",
    rulesTab: "요약",
    agreementTab: "전체 약관",
    insuranceRulesTitle: "보험 규칙",
    preview: {
      eventGroup: "一.이벤트 계약 예측 규칙",
      eventOpen: {
        title: "1. 보험 켜기",
        points: [
          "보험 ON 시 주문액/잔액 비율로 보험료: 잔액 10% 이하→15%, 초과→20%.",
          "보험 계좌 잔액 부족 시 보험 미적용"
        ]
      },
      eventLimit: {
        title: "2. 주문 한도",
        points: [
          "주문당 최대 5,000 JOULE"
        ]
      },
      eventClaim: {
        title: "3. 보상 권익 규칙",
        ok: [
          "보상의 50%는 개인 에어드롭 한도, 누적 50 USD마다 연산 노드 1개",
          "30%는 커뮤니티 VIP 규칙 한도, 누적 50 USD마다 연산 노드 1개"
        ],
        fail: [
          "전부 원금 상실, 예측 종료"
        ]
      },
      eventPool: {
        title: "4. 이벤트 보험 풀 보상:",
        points: [
          "풀 일일 자산 2% 상당 PANTA를 적격 사용자 노드 가중 에어드롭",
          "일일 에어드롭이 PANTA 환산 50 USD에 도달하면 노드 1개 감소"
        ]
      },
      eventProfit: {
        title: "5. 손익 규칙",
        points: [
          "적중: 원금 100% + 수익(80%)",
          "오예측: 전부 원금 상실, 예측 종료"
        ]
      },
      aiGroup: "二.AI 이벤트 계약 예측 규칙",
      aiFirst: {
        title: "1. 첫 주문은 수동 입력 필요"
      },
      aiOpen: {
        title: "2. 보험 켜기",
        points: [
          "보험 ON 시 포지션의 5%~10%를 보험료로 지불",
          "보험 계좌 잔액 부족 시 보험 미적용"
        ]
      },
      aiLimit: {
        title: "3. 주문 제한",
        points: [
          "금액은 포지션 표 준수, 방향은 AI와 일치",
          "표 미준수 시 일반 이벤트 계약 예측으로 전환",
          "연속 8패 시 규정 비율 보상",
          "수익 주문 시 시퀀스를 1단계로 리셋"
        ]
      },
      table: {
        level: "계정 등급",
        order1: "1주문",
        order2: "2주문",
        order3: "3주문",
        order4: "4주문",
        order5: "5주문",
        order6: "6주문",
        order7: "7주문",
        order8: "8주문"
      },
      claimOk: "보상 조건 충족",
      claimFail: "보상 조건 미충족",
      claimFailWhen: "보상 불가 시:",
      claimPrereq: "보상 전제:",
      aiClaim: {
        title: "4. 보상 권익 메커니즘",
        prereq: [
          "보험 ON",
          "AI 방향 일치",
          "표 순서/금액 일치",
          "완전 정산 조건 충족"
        ],
        ok: [
          "현금 보상 = 누적 손실 × 90%"
        ],
        fail: [
          "전부 원금 상실, 예측 종료"
        ]
      },
      aiProfit: {
        title: "5. 수익 규칙",
        points: [
          "적중: 원금 100% + 수익 80%",
          "오예측: 원금 상실, 종료 또는 보상"
        ]
      }
    },
    rulesContent: "PANTA Market 이벤트 계약 거래 보장 계획 보험 약관\n\n【중요 공지】본 서비스를 이용하기 전에 약관 전체를 주의 깊게 읽고 충분히 이해하시기 바랍니다. 사용자가 「보험 스위치」를 켜면 본 약관 및 첨부 내용을 충분히 읽고 이해·수락한 것으로 간주하며, 법적 구속력이 있음을 확인하고 엄격히 준수하는 데 동의한 것으로 봅니다. 동의하지 않으시면 즉시 본 보장 계획 이용을 중단하십시오.\n\n제1조: 약관 총칙 및 적용 범위\n\n1.1 본 약관은 PANTA Market 내 “이벤트 계약 예측”, “AI 이벤트 계약 예측” 두 기능의 참여 방식, 주문 성립, 수수료, 결과 판정, 자금 정산, 조건부 보상 및 관련 노드 권익·이벤트 예측 기능을 설명합니다. 두 상품은 각각 전용 조항이 적용되며, 한 상품의 요율·보상 조건·노드 규칙을 다른 상품에 그대로 적용할 수 없습니다.\n1.2 이벤트 계약 예측은 사전에 고지된 이벤트와 선택 결과에 대해 판단하고 JOULE로 제출하여 주문을 생성하는 기능입니다. 최종 적격 손실은 승인된 규칙에 따라 개인 또는 커뮤니티 팀 노드 한도를 생성할 수 있으며, 해당 한도는 즉시 현금 보상이 아닙니다. AI 이벤트 계약 예측은 시스템이 제공하는 유효 AI 방향 신호를 참고하여, 선택한 방안의 고정 금액과 순서에 따라 건별로 확인·참여하여 주문을 생성하는 기능입니다. 동일 적격 시퀀스의 8건이 전부 정산되고 모두 손실이며 기타 명시 조건을 동시에 충족하면, 적격 원금 합계의 90%를 JOULE로 보상합니다. AI 신호는 결과 보증이 아니며, 조건부 보상도 모든 지출을 포함하지 않습니다.\n1.3 본 약관, 해당 상품의 버전화된 파라미터, 구체 이벤트 규칙 및 사용자 확인 화면이 함께 완전한 규칙을 구성합니다. 화면은 이미 승인된 파라미터만 표시할 수 있으며, “화면 기준”으로 핵심 조건의 부재를 대체할 수 없습니다. 문서 간 모순이 있으면 영향받는 신규 거래를 중단하고 설명·검증·교정해야 하며, 사후에 사용자에게 불리한 해석을 일방적으로 적용해 기존 주문을 처리할 수 없습니다.\n1.4 본 프로젝트는 실물 자산, 이벤트 예측, 조건부 보상 및 보험 명칭, 팀 보상, 교환과 자금 풀을 포함하며, 리스크·컴플라이언스 심사를 생략할 수 있는 상품이 아닙니다. 각 기능의 법적 성격, 인허가, 제공 지역, 이용 자격, AML, 소비자 보호 및 데이터 처리 요건은 실제 서비스 범위에 맞춰 전문 검증을 완료해야 합니다. 면책 조항이 필요한 인허가·자금 배치·통제 조치를 대체하지 않으며, 본고는 특정 국가법을 전제하지 않고 상품이 이미 합법적으로 운영 허가되었다고 단정하지 않습니다.\n\n제2조: 용어와 자금 상태\n\n2.1 JOULE은 예측 원금·보험료 및 AI 보상 계측에 쓰이는 단위이고, PANTA는 노드 권익 배분 등 업무에 쓰이는 자산 단위이며, USDT 등가는 일부 한도·가치 산정에 쓰이는 계측 기준입니다. 셋을 혼용할 수 없으며, 내부 수치 표시가 고정 환율로 법정화폐에 즉시 환전됨을 뜻하지 않고, 온체인 이체가 완료되었음을 뜻하지도 않습니다. 이 설명은 이미 법령·약정에 따라 형성된 자산 권익이나 지급 의무를 소멸시키지 않습니다.\n2.2 주문 원금은 해당 주문에서 사용자가 실제로 확인하고 시스템이 수락한 JOULE 금액이며 보험료를 포함하지 않습니다. 보험료는 해당 주문에 적용되는 규칙으로 산정된 비용입니다. 동결 총액은 통상 원금과 보험료의 합이며, 추가 비용이 있으면 사전에 각각 고지해야 하고 정산 시 미확인 요금을 추가할 수 없습니다.\n2.3 가용 잔액은 현재 계정 규칙하에서 신규 조작에 쓸 수 있는 잔액입니다. 동결 잔액은 수락된 주문 또는 승인된 업무를 위해 예비되어 당분간 다른 조작에 쓸 수 없는 잔액입니다. 예상 수익, 심사 대기 보상, 노드 한도 및 미입금 배분은 가용 잔액에 포함되지 않습니다. 잔액 표시에는 자산명을 명시해야 하며, 서로 다른 자산 수량을 단순 합산할 수 없습니다.\n2.4 AI 시퀀스는 동일 확정 방안에 대해 1건부터 규칙에 따라 이어지는 업무 기록입니다. 현재 단계, 주문 결과 및 자격 증빙은 서버가 유지합니다. 정상 단절이나 앱 종료는 시퀀스 업무 종료가 아니며, 리셋은 본 약관 조건 충족 후 구 시퀀스를 종료하는 것입니다.\n2.5 연산력 노드 한도는 최종 적격 손실을 규칙에 따라 누적해 노드 생성에 쓰는 USDT 등가 장부 단위입니다. 노드는 이후 권익 배분 참여 자격 기록이며, 즉시 현금·입금된 PANTA가 아니고, 명칭만으로 거래·예치·자유 양도 가능한 온체인 NFT가 되지도 않습니다.\n2.6 규칙 스냅샷은 주문 또는 시퀀스 확정 시 저장된 규칙 버전, 파라미터, 금액, 가격 근거, 조항 및 관련 증빙입니다. 신규 버전 배포가 구 스냅샷을 덮어쓸 수 없습니다. 서버 기록은 상태 검증에 사용되지만, 사용자는 다른 증빙으로 재심을 신청할 수 있으며, 기록이 플랫폼에 보관된다는 이유만으로 합리적 이의를 배제할 수 없습니다.\n\n제3조: 이용 자격과 약관 확인\n\n3.1 플랫폼은 승인된 서비스 지역, 연령 및 적합성 범위 내의 사용자에게만 해당 기능을 제공할 수 있습니다. 정식 버전은 신원 검증 요건, 상품 이용 범위 및 제한 사유를 명시해야 합니다. 지갑 연결, 화면 표시 또는 잔액만으로 모든 상품 참여 자격을 인정할 수 없습니다.\n3.2 사용자는 본인이 통제할 권한이 있는 계정과 자산을 사용해야 하며, 신원 도용, 무단 타인 계정 사용, 자격 자료 위조, 신호·결과 증빙 조작을 해서는 안 됩니다. 플랫폼이 추가 검증이 필요하면 필요 자료와 업무 목적을 설명해야 하며, 신규 참여 제한과 기존 주문 이행은 각각 설명해야 합니다.\n3.3 주문 전 사용자는 원금, 보험료, 추가 비용 가능성, 예측 옵션, 최악 손실, 정산 조건, 판정 출처 및 분쟁 경로를 열람할 수 있어야 합니다. 플랫폼은 명확한 확인 절차를 제공해야 하며, 기본 동의·숨은 비용·자동 금액 전환·반복 조작 재촉으로 진정한 확인을 대체해서는 안 됩니다.\n3.4 AI 신호, 과거 결과, 예시 수익, 노드 풀 규모 및 타인 권익 기록은 미래 결과 약속이 아닙니다. 사용자는 수락된 주문의 원금과 관련 보험료를 잃을 수 있으며, 노드 권익도 풀 잔액·유효 가중치·가격·처리 상태의 영향을 받을 수 있습니다. 특정 예시를 본인의 고정 수익이나 확정 회수 기간으로 여겨서는 안 됩니다.\n\n제4조: 이벤트 계약 예측 규칙\n\n4.1 AI 시퀀스 시작 전 사용 가능 방안, 실행 포지션 원금, 예상 보험료, 합계 자금 수요, 신호 유효기간, 60초 정산 규칙 및 90% 보상 조건을 확인해야 합니다. 신규 시퀀스는 1건부터만 시작할 수 있고, 진행 중 방안을 바꿀 수 없으며, 건너뛰기·금액 변경·병렬 미결 주문으로 새 적격 시퀀스를 조합할 수 없습니다. 사용자가 이벤트 결과를 선택하고 JOULE 원금을 입력하면, 플랫폼은 승인된 포지션 기준으로 보험료를 산정합니다. 현재 설계: 원금이 기준의 10% 이하이면 원금의 15%, 초과하면 20%, 정확히 10%이면 15%를 적용합니다.\n4.2 AI 신호는 대상, 방향, 시간, 유효기간 및 식별 가능한 신호 번호를 표시해야 합니다. 주문 시 당시 유효 신호와 일치하는 방향을 확인해야 합니다. 대기·재연결 중 신호가 갱신되면 재검증해야 하며, 만료 신호는 클라이언트 캐시로 계속 쓸 수 없습니다. AI 신호 채택이 플랫폼이나 알고리즘이 미래 결과를 안다는 뜻이 아닙니다. 과거 정확도·데모·예측 설명은 본건 결과 보증이 될 수 없습니다. 플랫폼은 “무조건 승리”“확정 수익”“틀려도 무손실” 등으로 실제 원금·보험료·보상 조건을 대체해서는 안 됩니다.\n4.3 각 이벤트는 명칭, 사실 설명, 선택 결과, 개시·마감 시점, 시간대, 참여 한도, 결과 판정 기준, 주·예비 증빙 출처, 수익 계산, 최악 손실, 취소·연기 규칙 및 이의 절차를 독립적으로 명시해야 합니다. 모호한 이벤트, 판정 기준 부재 또는 핵심 경제 파라미터가 미승인인 이벤트는 실거래 주문을 열 수 없습니다. 수락 시 이벤트가 여전히 개방인지, 서버 시간이 마감 전인지, 옵션·버전이 유효한지, 자격·한도·잔액이 충분한지 재확인해야 합니다. 마감 판단은 사용자 기기 시간이나 클릭 시 클라이언트 카운트다운이 남아 있는지로 하지 않습니다.\n4.4 원금·보험료 동결 성공 및 주문 수락 후, 플랫폼은 수락 시간과 약정 정산 시점을 반환합니다. 해당 시점은 서버 수락 시간+60초이며, 페이지 열람·신호 수신·버튼 클릭부터 계산하지 않습니다. 네트워크 지연이 이미 확정된 판정 기준을 늘리거나 줄이지 않습니다. 60초는 약정 결과 판정 시점이며, 클라이언트 카운트다운이 0이 되는 그 순간에 입금 완료를 약속하지 않습니다. 시점 도래 후 약정 출처의 결과 증빙을 확보해야 하며, 증빙 없음·출처 이상·결과 충돌 시 정산 대기를 유지하고 상태를 설명해야 하며 자동으로 손실 처리할 수 없습니다.\n4.5 현재 유효 시퀀스이고 규칙이 명확히 표시되며 미결 주문이 없는 상태에서, 사용자가 유효 신호와 다른 방향 또는 현재 고정 단계와 다른 금액을 실제로 제출한 경우에만 거절 및 구 시퀀스 종료 리셋이 적용됩니다. 구체 사유, 영향 시퀀스 및 다음 실행 가능 조작을 표시하고 이력을 보존해야 합니다. 리셋 후 다음번에는 1건부터 새 시퀀스를 만들 수 있으며, 구 시퀀스 손실 주문과 신 시퀀스를 이어 붙여 8연패를 계산할 수 없습니다. 구 시퀀스에서 완료된 손익은 유지되며 자동으로 90% 보상을 받지 않으나, 플랫폼 오류·잘못된 리셋 등 분쟁에 대한 재심 신청을 막지 않습니다.\n4.6 거절된 위반 요청 자체는 체결되지 않으며 신규 원금 손실·보험료·손실 노드를 만들지 않습니다. 위반 손실을 노드로 전환한다는 초안 표현은 아직 실행 가능한 규칙이 아니며, 거절 건에 허위 손실이나 보상을 만들 수 없습니다.\n4.7 이후 단계 개시를 일시 중단한다고 해서 이미 8연패가 된 것이 아니며, 미완료 시퀀스는 손실 건수 비율로 90% 보상을 청구할 수 없습니다. 시퀀스 자발 종료·장기 체류·복구 기한은 정식 규칙 확인이 필요하며, 미고지 만료 시간을 임의로 추가할 수 없습니다. 정상 종료·단절을 자발적 포기로 해석할 수 없습니다. 동일 시퀀스가 다음 네 조건을 동시에 충족할 때만 현재 설계의 90% JOULE 보상을 산정합니다: 각 건 보험 메커니즘이 유효히 켜지고 해당 원금·보험료가 실제로 동결됨; 각 방향이 수락 시 유효 AI 신호와 일치; 각 원금·단계 순서가 확정 방안과 일치; 8건이 전부 완전 정산되고 결과가 모두 적격 손실. 보상 금액은 적격 8건 참여 원금 합계×90%이며 JOULE로 계량·지급하고, 보험료는 해당 90% 기준에 들어가지 않습니다. 보상을 전체 지출의 90% 반환으로 직접 표현할 수 없으며 USDT·현금·PANTA로 자동 환산되지 않습니다. 다른 자산 교환은 별도 규칙과 권한이 필요합니다.\n4.8 보상 자격 성립과 지급 성공은 두 단계입니다. 자격은 있으나 자금 부족·장부 이상·적용 제한이 있으면 지급 대기 의무와 명세를 유지하고 처리 중 또는 명확한 보류 사유를 표시한 뒤 법령·약정에 따라 처리해야 하며, 지급 곤란을 자격 미달로 바꿔 쓸 수 없습니다.\n4.9 보상은 해당 시퀀스의 유일한 기록으로 한 번만 실행합니다. 지급은 성공했으나 응답이 유실되면 이후 조회·재시도는 원래 결과를 반환하고 중복 지급하지 않습니다. 지급 실패는 실제 미완료 상태를 유지해야 하며, 새 시퀀스 생성이나 재주문으로 원래 보상을 “활성화”하도록 요구할 수 없습니다. 사전 확인 메커니즘에 따라 건별 요율이 다를 수 있으면 건별 스냅샷을 남기고 실제 비용을 누적해야 하며, 현재 한 요율로 모든 과거 주문을 재계산할 수 없습니다. 이미 확정된 시퀀스에 영향을 주는 요율 변경은 적용 범위를 먼저 명확히 해야 하며, 새 화면으로 소급해 비용을 늘릴 수 없습니다.\n4.10 자산 최소 단위, 정밀도, 건별 반올림 및 잔차 처리는 배포 전 확정하고 일관되게 유지해야 합니다. 화면 가독을 위한 반올림이 장부 명세를 바꿔서는 안 되며, 계산 예시의 정밀도는 승인된 지급 정밀도가 아닙니다. 수수료·스프레드·잔차를 병합 표시로 숨길 수 없습니다.\n\n제5조: 시스템 서비스\n\n5.1 단절 또는 요청 시간 초과: 사용자는 먼저 원 주문을 조회하고, 플랫폼은 수락·명확 거절·확인 대기 중 실제 상태를 반환합니다. 결과가 불명일 때 중복 결제를 유도해서는 안 되며, 이후 미수락으로 확정된 뒤에야 현행 유효 규칙으로 새 요청을 다시 확인할 수 있습니다.\n5.2 신호 또는 호가 만료: 구 요청을 거절하고 사유를 표시한 뒤 내용을 다시 가져옵니다. 새 방향·금액·비용을 묵시적으로 바꾸거나, 만료를 자동 AI 위반 리셋으로 취급해서는 안 됩니다. 구 요청이 이미 수락되었다면 해당 스냅샷대로 이행합니다.\n5.3 결과 또는 가격 이상: 영향받는 판정·평가·배분을 일시 중단하고 상태·범위·조회 경로를 제공합니다. 결과 부재를 실패 손실로 기록할 수 없고, 이상 평가로 손실 기준을 키울 수 없습니다. 예비 출처 교체는 사전 공표된 출처 순서와 이상 규칙을 따라야 합니다.\n5.4 장부 차이 또는 외부 거래 상태 불명: 먼저 원기록과 외부 회신을 검증하고 비가역 동작을 반복 보내지 않습니다. 실패 확정 후 해당 규칙에 따라 해동하거나 재시도하며, 불명은 환불 완료가 아닙니다. 완료된 사용자 자금 동작과 미완료 후속 매수·입풀 단계는 각각 표시해야 합니다.\n5.5 자금 부족: 부족을 키울 수 있는 관련 신규 업무를 중단하고, 이미 형성된 의무를 유지하며, 처리 대기 상태를 알리고 승인된 방안으로 처리합니다. 입금 완료를 위조하거나 가용 잔액을 음수로 바꾸거나 미고지 추가 요금으로 차액을 메울 수 없습니다.\n5.6 리스크 제한: 플랫폼은 정식 승인·적절히 고지된 규칙에 따라 필요한 검증이나 제한을 할 수 있으나, 신규 주문 제한·지급 지연·자격 취소를 구분해야 합니다. 제한이 과거 승패나 이미 충족된 경제 조건을 자동으로 고쳐 쓸 수 없으며, 예외 적용에는 사실과 근거가 필요하고 이용 가능한 재심 경로를 제공해야 합니다.\n5.7 유지보수·서비스 중단·특정 상품 종료 시에도 과거 주문·보상·분쟁·대조 가능 기록에 대한 처리 방안이 있어야 합니다. 신규 거래를 못 한다고 기존 잔액·지급해야 할 보상·이의 권리가 사라지지 않습니다. 신규 업무 스위치를 끄는 것이 모든 과거 조회·이행 절차까지 함께 닫아서는 안 됩니다.\n\n제6조: 면책 조항\n\n다음 사유로 인한 손실에 대해 서비스는 배상 책임을 지지 않습니다.\n6.1 전략 미준수: 본 플랫폼 표준 포지션 관리 규정을 벗어난 모든 행위\n6.2 극단 시장 조건: 거래소 마비, 유동성 고갈, 시장 조작으로 인한 손실\n6.3 시스템·운영 리스크: 사용자 기기 고장, 조작 실수, 계정 도용으로 인한 손실\n6.4 정책·컴플라이언스 리스크: 법령·규제 명령 변경으로 인한 거래 중단 또는 금지\n6.5 내재 토큰 리스크: JOULE 시가총액 급락 또는 붕괴로 마진·정산 통화 기능이 영향받는 경우\n6.6 사기·악성 행위: 사기, 자금세탁, 시장 조작 또는 기타 위법 행위\n6.7 불가항력: 불가항력으로 인한 본 플랫폼 시스템 장애\n\n제7조: 위험 고지\n\n사용자는 다음 위험을 충분히 이해하고 수락함을 확인합니다.\n7.1 원금·수익 미보장: 본 계획은 일부 손실만 보상하며 원금 안전이나 수익을 절대 보장하지 않습니다\n7.2 전략 의존 위험: 보장 효과는 전략의 엄격한 준수에 전적으로 달려 있습니다\n7.3 유동성·잠금 위험: 보상 자금이 자산관리 계정에 들어가면 투자 위험과 잠금 기간이 있을 수 있어 유동성에 영향을 줍니다\n7.4 제3자 위험: 의존하는 거래소의 운영·보안·가치 변동 위험\n7.5 규제 불확실성: 글로벌 규제 불확실성 및 중단 위험\n7.6 기술 보안 위험: 스마트계약 취약점, 해킹 등으로 인한 자산 손실 위험 포함\n\n제8조: 약관 변경·종료 및 분쟁\n\n8.1 약관 변경: 플랫폼은 법령 또는 운영 필요에 따라 본 약관을 개정할 수 있으며, 중대 변경은 플랫폼 공지로 알립니다\n8.2 약관 종료: 사용자는 언제든 보장 스위치를 꺼 서비스를 종료할 수 있고, 약관 위반 시 플랫폼이 일방 종료할 수 있으며, 법률·정책 사유로 본 계획이 종료될 수 있습니다\n8.3 분쟁 해결: 본 약관으로 인한 분쟁은 우선 우호 협의로 해결하고, 협의 불성립 시 지정 중재기관 또는 법원에 제출합니다\n\n【최종 확인】「보험 스위치 사용」이 본 약관 전체에 구속됨을 확인하는 유일하고 최종적인 방식임을 이해하고 동의하며, 독립적 판단에 따라 결정하시기 바랍니다.",
    lockedBalance: "이체 불가",
    equityTitle: "일반 보험 권익",
    personalEquity: "개인 권익",
    teamEquity: "팀 권익",
    equityNodes: "유효 노드",
    remainingEquity: "잔여 권익",
    peersPaid: "동급 지급됨",
    peersPending: "동급 대기",
    creditsCount: "권익 건수",
    nodeBatches: "노드 배치",
    peerRows: "동급 대기 건수",
    recentPayouts: "최근 일일 정산",
    premiumRules: "포지션 임계값 {threshold}% · 낮은 보험료 {low}% · 높은 보험료 {high}% (본 주문은 미리보기 기준)",
    insuranceDeduction: "보험 공제",
    insurancePayout: "보험 지급"
  },
  walletBind: {
    connectWallet: "연결",
    inputPlaceholder: "주소 입력",
    bind: "바인드",
    binding: "바인딩 중",
    tip: "팁: 지갑 연결에 문제가 있는 경우 지갑 주소를 수동으로 입력하여 바인드할 수 있습니다"
  },
  loginModal: {
    title: "PANTA MARKET 로그인",
    connectWallet: "연결",
    connecting: "연결 중...",
    alreadyConnected: "연결됨",
    tip: "팁: 지갑 연결에 문제가 있는 경우 지갑 주소를 수동으로 입력하여 바인드할 수 있습니다",
    inputLabel: "지갑 주소 입력",
    inputPlaceholder: "0x234d456f6798...",
    bind: "바인드",
    binding: "바인딩 중",
    bindSuccess: "바인드 성공",
    bindSuccessHint: "바인드 성공, 다시 로그인하세요",
    bindFailed: "바인드 실패",
    noAuthCode: "인증 코드 누락",
    invalidAddress: "잘못된 지갑 주소 형식",
    confirmTitle: "바인드 확인",
    confirmWarning: "다음 주소가 귀하의 지갑 주소인지 신중하게 확인하십시오. 바인드 후에는 변경할 수 없습니다",
    addressLabel: "지갑 주소",
    cancel: "취소",
    confirm: "바인드 확인",
    loginSuccess: "로그인 성공",
    openWalletApp: "{wallet} 열기",
    openWalletConnect: "{wallet} 열어 연결",
    openWalletSign: "{wallet} 열어 서명",
    returnToBrowser: "완료 후 이 페이지로 돌아와 주세요",
    loginStepLabel: "단계 {step}/2",
    stepConnectTitle: "지갑 연결",
    stepConnectHint: "지갑에서 연결을 승인한 뒤 이 페이지로 돌아와 주세요",
    stepConnectHintWithOpen: "아래를 눌러 지갑을 열고 연결을 승인한 후 돌아와 주세요",
    stepSignTitle: "서명 로그인",
    stepSignHint: "지갑에서 로그인 메시지에 서명하세요(자산이 이동하지 않음). 완료 후 돌아와 주세요",
    stepSignHintWithOpen: "한 단계 더: 아래를 눌러 지갑을 열고 로그인 메시지에 서명하세요",
    waitingWalletHintShort: "자동으로 열리지 않으면 아래를 눌러 지갑을 여세요",
    retryLogin: "로그인 다시 시도",
    networkRequired: "네트워크 전환 필요",
    networkRequiredHint: "{chain}(으)로 전환한 뒤 이 페이지로 돌아와 다시 시도하세요",
    switchingNetwork: "네트워크 전환 확인",
    switchingNetworkHint: "지갑에서 {chain}(으)로 전환을 승인하세요",
    signatureRequired: "서명하여 로그인",
    signatureHint: "지갑에서 서명하세요. 자산이 이동하지 않습니다",
    verifyingLogin: "확인 중",
    verifyingHint: "잠시만 기다려 주세요",
    connectFailed: "연결이 완료되지 않았습니다. 다시 시도하세요",

    waitingWalletReturn: "지갑에서 승인 후 이 페이지로 돌아와 주세요",
    waitingWalletHint: "지갑에서 승인해 주세요. 완료 후 자동으로 돌아옵니다"
  },
  walletProfile: {
    title: "프로필",
    address: "주소",
    accountName: "계정 이름",
    inviteCode: "초대 코드",
    deactivateAccount: "계정 비활성화",
    logout: "로그아웃",
    switchAccount: "계정 전환",
    confirmLogout: "로그아웃하시겠습니까?",
    loggingOut: "로그아웃 중...",
    confirmSwitch: "계정을 전환하시겠습니까? 현재 계정이 로그아웃됩니다",
    developing: "개발 중",
    addressCopied: "주소가 복사되었습니다",
    inviteCodeCopied: "초대 코드가 복사되었습니다"
  },
  aiPrediction: {
    stakeAutofill: "AI 보조",
    stakeAutofillWarning: "보조 기능입니다. 추천 금액이 틀릴 수 있으니 주문 전 확인해 주세요. 지연이 800ms를 초과하거나 연결 검사 실패·만료 시 자동 입력을 일시 중지하며, 복구 후 다시 이어집니다. 수동 주문에는 영향이 없습니다.",
    stakeAutofillUnavailable: "연결이 불안정하거나 지연이 800ms를 초과해 아직 켤 수 없습니다",
    stakeAutofillPaused: "연결이 불안정해 자동 입력이 일시 중지되었습니다. 금액을 직접 입력하세요",
    insuranceSyncing: "보험 단계 동기화 중…",
    predictionBuffer: '다음 예측 준비 중',
    scheduleResultPending: '이번 회차 결과를 다시 확인 중',
    tierSelection: "AI 보험 등급",
    tierSaving: "등급 확인 중, 중복 조작하지 마세요",
    tierUnknown: "등급 결과 확인 대기, 조회 후 다시 시도하세요",
    tierPending: "적용 대기 등급(서버 확인 결과 기준)",
    ordinaryPreviewHint: "현재 금액이 AI 포지션에 맞지 않아 일반 보험으로 미리보기·확인합니다",
    title: "AI 예측",
    bookingTitle: "AI 회차 예약",
    bookingExpand: "펼치기",
    bookingCollapse: "접기",
    bookingNextSystem: "시스템 다음 회차 · SGT",
    bookingNextMine: "내 다음 예약",
    bookingNone: "없음",
    bookingStartingSoon: "예약한 회차가 곧 시작됩니다",
    bookingToday: "오늘",
    bookingTomorrow: "내일",
    bookingTimezone: "SGT",
    bookingQuota: "남은 참가 {remaining}/{dailyLimit}회",
    bookingSeats: "{occupied}/{capacity}명",
    bookingEmpty: "이용 가능한 회차 없음",
    bookingWaiting: "현재 작업이 끝나면 자동으로 입장합니다",
    bookingEnded: "종료됨",
    bookingJoin: "이 회차 참가",
    bookingReserve: "예약",
    bookingJoined: "입장 완료",
    bookingReserved: "예약됨",
    bookingFull: "마감",
    bookingConfirm: "예약 확인",
    bookingWarning: "예약 성공 시 해당일 1회가 차감되며, 미참석해도 차감됩니다.",
    bookingQuotaExhausted: "당일 참가 가능 횟수를 모두 사용했습니다",
    bookingUnavailable: "현재 예약할 수 없습니다",
    bookingFailed: "예약 실패. 새로고침 후 다시 시도하세요.",
    countdown: "카운트다운",
    expectedProfit: "예상 수익",
    active: "활성",
    aiAnalysis: "AI 상승/하락 확률 분석",
    updateTime: "업데이트 시간",
    probabilityUp: "상승 확률",
    probabilityDown: "하락 확률",
    startPrediction: "예측 시작",
    startAIPrediction: "AI 예측 시작",
    scheduleConfirm: "따라가기 주문",
    scheduleBinding: "시그널 연결 중...",
    ruleScore: "규칙 점수 {score}, 승률이 아닙니다",
    selectTier: "보험 등급을 선택하세요",
    scheduleUnscheduled: "아직 일정 없음",
    scheduleWaiting: "다음 시간대 대기",
    schedulePreparing: "{round}라운드 준비 중",
    scheduleUnavailable: "현재 주문 불가",
    scheduleFinished: "이번 라운드 종료",
    predicting: "예측 중...",
    stayOnPageHint: "현재 페이지를 떠나지 마세요. 예측 결과가 사라질 수 있습니다",
    waitingResult: "결과 대기",
    predictionResult: "예측 결과",
    nextRound: "다음 라운드",
    aiPool: "AI 보험 풀",
    orderWindowLabel: "주문 잔여",
    eventContract: "이벤트 계약",
    stakeFromStrategy: "포지션은 전략이 지정",
    stakeTier: "등급 {tier}",
    stakeStep: "{step}단계",
    tierMatched: "{tier}등급 매칭 · {step}/{total}단계",
    tierBound: "현재 {tier}등급 · {step}/{total}단계, 본 단계 요구 {amount} JOULE",
    tierBoundNoStake: "현재 {tier}등급 · {step}/{total}단계",
    amountNotAi: "현재 금액이 AI 보험 요건에 맞지 않습니다",
    amountInvalid: "최소 0.1 JOULE, 소수점 최대 18자리",
    tierAmbiguous: "보험 등급 규칙이 모호하여 시작할 수 없습니다",
    premiumEstimateAmount: "예상 보험료 {premium} JOULE",
    ordinaryInsuranceTitle: "본 주문은 일반 보험입니다",
    ordinaryInsuranceBody: "본 주문은 일반 보험이며 AI 라운드 지급이 아닙니다. 확인 후 미리보기 보험료로 제출합니다.",
    sessionConflict: "진행 중인 AI 보험 라운드가 있습니다. 복구하거나 종료한 뒤 일반 보험을 진행하세요",
    conversionTitle: "일반 보험으로 전환할까요?",
    conversionDesc: "본 주문은 일반 보험으로 전환되며 이번 AI 보험 라운드가 종료됩니다. 이전 AI 연속 손실은 지급되지 않습니다. 일반 보험료 {premium} JOULE.",
    conversionConfirm: "전환 후 주문",
    orderSuccess: "AI 예측 주문 성공!",
    orderFailed: "AI 예측 주문 실패",
    orderConfirming: "AI 예측 주문 결과 확인 중, 중복 조작하지 마세요",
    orderNotFilled: "이번 AI 예측 주문이 체결되지 않았으며 차감되지 않았습니다",
    recoverTitle: "미완료 AI 예측 주문 확인",
    recoverContent: "미확인 AI 예측 주문({symbol} {direction} {amount})이 있습니다. 원 멱등 키로 확인하며 중복 주문하지 않습니다.",
    recoverConfirm: "주문 확인",
    recoverCancel: "취소",
    userInfo: "사용자 정보",
    predictCount: "예측 횟수",
    freeCount: "무료 예측 횟수",
    selfQuotaRemaining: "자율 예측 잔여 횟수: {remaining}/{limit}",
    followRoundProgress: "AI 따라하기 · {current}/{total}회차",
    followRoundsCompleted: "AI 따라하기 완료 · {current}/{total}",
    selfQuotaLoadingShort: "횟수 로딩 중",
    selfQuotaLoginHint: "로그인 후 횟수 확인",
    selfQuotaLoading: "횟수 로딩 중, 잠시 후 다시 시도하세요",
    selfQuotaExhausted: "오늘 무료 자율 예측 횟수를 모두 사용했습니다. 유료 예측은 아직 개방되지 않았습니다",
    openTime: "시작 시간: {time1}",
    up: "상승",
    down: "하락",
    rise: "상승",
    fall: "하락",
    notConnected: "미연결",
    count: "횟수",
    learnMore: "자세히 보기",
    calculating: "계산 중...",
    settled: "정산 완료",
    settling: "정산 중",
    syncingTime: "시간 동기화 중",
    settledAt: "정산 시간:",
    refunded: "환불됨",
    won: "수익",
    lost: "손실",
    position: {
      calculating: "계산 중...",
      settled: "정산 완료",
      settling: "정산 중",
      syncingTime: "시간 동기화 중"
    },
    loginFirst: "먼저 로그인하세요",
    sessionSyncing: "동기화 중",
    openPrice: "진입가",
    closePrice: "청산가",
    profitLoss: "손익",
    actions: {
      rise: "상승",
      fall: "하락"
    },
    holdings: {
      current: "현재 포지션",
      history: "기록",
      aiHistory: "AI 기록",
      empty: "포지션 없음",
      historyEmpty: "기록 없음",
      aiHistoryEmpty: "AI 기록 없음"
    },
    buyModal: {
      title: "AI 예측 특권 구매",
      description: "{amount}{symbol} 결제 시 AI 예측 {times}회를 추가로 받습니다.",
      upgradeAmount: "업그레이드 금액",
      balance: "현재 가용 잔액",
      cancel: "구매 취소",
      confirm: "구매 확인",
      purchasing: "구매 중...",
      purchaseSuccess: "구매 성공",
      purchaseFailed: "구매 실패",
      dailyLimit: "하루 최대 1회 구매할 수 있습니다."
    },
    noPredictionAlert: {
      title: "AI 예측 시작 실패",
      description: "AI 예측 횟수가 0이라 기능을 사용할 수 없습니다. 구매 후 이용해 주세요.",
      cancel: "구매 취소",
      confirm: "구매 확인"
    },
    toasts: {
      deferredWaitSettlement: "예측이 생성되었습니다. 현재 포지션 정산 후 주문하세요",
      insuranceCancelFailed: "종료 실패, 미정산 주문이 있을 수 있습니다",
      insuranceTierUnavailable: "먼저 보험 등급을 선택하세요",
      amountTierMismatch: "입력 금액이 보험 등급에 맞지 않습니다",
      bindStakeChanged: "서버 요구 원금이 입력과 달라 기존 주문을 중단했습니다",
      predictionFailed: "예측 실패",
      predictionSuccess: "예측 완료",
      premiumShortfallReminder: "전체 라운드 예상 보험료 부족약 {amount} JOULE(참고, 본 주문은 전략 포지션으로 제출 가능)",
      requiredStakeInvalid: "예측 포지션이 유효하지 않습니다. AI 예측을 다시 시작하세요",
      resumeFailed: "예측 복구 실패, 잠시 후 다시 시도하세요",
      onlyBtcUsdt1m: "AI 예측은 BTC/USDT 1분 모드만 지원합니다",
      entryWindowExpired: "진입 창이 만료되었습니다. AI 예측을 다시 시작하세요",
      scheduleRoundRequired: "먼저 현재 라운드를 동기화하세요",
      scheduleNotReady: "결과가 아직 공개되지 않았습니다. 잠시 기다려 주세요",
      scheduleExpired: "이번 라운드가 마감되었습니다. 다음 라운드를 기다리세요",
      scheduleUnavailable: "예약 예측을 사용할 수 없습니다",
      unsettledConflict: "미정산 포지션이 있습니다. 잠시 후 주문하세요",
      orderWindowExpired: "주문 시간이 종료되었습니다. AI 예측을 다시 시작하세요"
    },
    previousOrder: {
      title: "이전 주문",
      won: "수익",
      lost: "손실",
      refunded: "환불됨",
      pending: "정산 대기",
      review: "확인 중"
    },
    analyzing: "분석 중...",
    insurance: "보험",
    insuranceOn: "적용됨",
    insuranceOff: "미적용",
    aiLabel: "AI",
    lookLong: "상승",
    lookShort: "하락"
  },
  positionModal: {
    title: "가격 예측",
    insurance: "보험",
    long: "롱",
    short: "숏",
    balance: "잔액",
    loading: "로딩 중...",
    confirm: "확인",
    processing: "주문 처리 중...",
    success: "주문이 성공적으로 완료되었습니다!",
    insuranceOn: "보험이 활성화되었습니다",
    insuranceOff: "보험이 비활성화되었습니다",
    operationFailed: "작업 실패",
    balanceFetchFailed: "잔액을 가져오지 못했습니다",
    minAmount: "최소 금액은 0.1 TAKER입니다",
    insufficientBalance: "잔액 부족, 현재 잔액: {balance} TAKER",
    createFailed: "포지션 생성 실패",
    recoverTitle: "Recover pending order",
    recoverContent: "Unconfirmed order found ({symbol} {direction} {amount}). Will reuse the original idempotency key without requoting.",
    recoverConfirm: "Recover",
    recoverCancel: "Cancel"
  },

  appeal: {
    title: "자산 보조 심사",
    records: "제출 기록",
    recordsTitle: "제출 기록",
    noRecords: "제출 기록 없음",
    submitTime: "제출 시간",
    statusPending: "처리 중",
    statusApproved: "승인",
    statusRejected: "반려",
    failedReason: "거부 사유",
    uniLiveUid: "UniLive ID",
    uniLiveUidLoading: "로딩 중...",
    walletAddress: "PANTA MARKET에 바인딩된 주소",
    address: "주소",
    walletAddressPlaceholder: "PANTA MARKET 로그인 주소 입력",
    autoFill: "자동 입력",
    depositAmount: "입금 금액",
    depositAmountPlaceholder: "입금 금액 입력",
    tokenType: "토큰 유형",
    selectToken: "토큰 선택",
    tokens: {
      usdt: "USDT",
      taker: "JOULE"
    },
    transferTime: "송금 시간",
    selectTime: "송금 시간 선택",
    timeRangeHint: "2026년 3월 5일 00:00 ~ 3월 11일 10:00(SGT) 사이에 발생한 관련 데이터.",
    txHash: "HASH / TXID",
    txHashPlaceholder: "트랜잭션 해시 입력",
    txHashHint: "블록체인 탐색기에서 확인 가능",
    uploadImages: "송금 기록 스크린샷",
    uploadHint: "선택 사항, 최대 9개 이미지 업로드",
    addImage: "이미지 추가",
    submit: "제출",
    submitting: "제출 중...",
    submitSuccess: "제출이 완료되었습니다",
    submitFailed: "제출 실패, 다시 시도하세요",
    uploadingImages: "이미지 업로드 중...",
    uploadImagesFailed: "이미지 업로드 실패",
    warningTitle: "중요 공지",
    warningText: "제출된 기록이 검증에 성공하면 구독 파워의 5%가 보상으로 지급됩니다. 허위 정보를 제공하면 계정이 동결됩니다."
  },
  withdrawSheet: {
    title: "출금",
    balance: "잔액",
    processing: "TAKER 출금 중...",
    success: "TAKER 출금 성공!",
    withdrawing: " 출금 중...",
    withdrawSuccess: " 심사 대기 중",
    recordBadge: "출금 기록",
    sheetTitle: "{token} 출금",
    sheetDesc: "출금 금액을 입력하세요. 최소 {min} USDT. 수수료 없음.",
    available: "가용 {token}",
    amountPlaceholder: "금액 입력(최소 {min} USDT)",
    amountLabel: "출금 금액",
    feeHint: "예상 수수료는 참고용이며, 최종 fee/net은 서버 생성 응답 기준입니다",
    vault: "Vault 컨트랙트",
  },
  depositSheet: {
    title: "TAKER 입금",
    depositTo: "입금처",
    spotAccount: "현물 계정",
    network: "네트워크",
    networkWarning: "BSC/BEP20 네트워크 입금만 지원됩니다. 다른 네트워크 사용으로 인한 자산 손실은 복구할 수 없습니다.",
    depositAddress: "입금 주소",
    address: "주소",
    depositTAKER: "TAKER 입금",
    recharge: "충전",
    rechargeAddress: "충전 주소",
    copy: "복사",
    copySuccess: "복사 성공",
    loadingAddress: "충전 주소를 가져오는 중...",
    loadAddressFailed: "충전 주소 가져오기 실패",
    clickToRetry: "다시 시도하려면 클릭",
    generating: "생성 중...",
    generateSuccess: "생성 성공",
    generateFailed: "생성 실패",
    saveAndShare: "주소 저장 및 공유",
    more: "더보기",
    save: "저장",
    wechat: "위챗",
    recordBadge: "입금 기록",
    sheetDesc: "지갑에서 플랫폼 잔액으로 {token} 입금",
    telegram: "Telegram",
    discord: "Discord",
    x: "X",
    savedImage: "저장된 이미지",
    download: "다운로드",
    pleaseGenerate: "먼저 이미지를 생성하세요",
    downloadSuccess: "다운로드 성공",
    saveSuccess: "저장 성공",
    saveFailed: "저장 실패",
    needPermission: "앨범에 이미지를 저장하려면 권한이 필요합니다",
    pleaseUseDapp: "지갑을 사용하여 DApp을 열어주세요",
    claimDesc: "입금 주소로 USDT를 보낸 뒤 트랜잭션 해시를 붙여넣어 청구하세요",
    claimButton: "입금 청구",
    environment: "환경",
    txHash: "트랜잭션 해시",
    txHashPlaceholder: "0x 트랜잭션 해시 붙여넣기",
    optionalAmount: "금액(선택 메모)",
    wallet: "지갑",
    max: "최대",
    confirmations: "필요 확인 수",
    envMainnet: "메인넷",
    envTestnet: "테스트넷",
    loading: "로딩 중...",
    loadFailed: "입금 주소 가져오기 실패",
    stepsTitle: "입금 단계",
    step1: "네트워크와 입금 주소를 확인하고, 해당 주소로만 설정된 USDT를 송금하세요",
    step2: "지갑에서 온체인 송금을 완료하세요",
    step3: "트랜잭션 해시를 붙여넣어 청구하고, 입금 기록에서 진행 상황을 확인하세요",
    tokenContract: "USDT 컨트랙트",
  },
  sidebar: {
    loginAccount: "로그인 계정",
    inviteBanner: "친구 초대하고 팀 수수료 받기",
    inviteCode: "초대 코드",
    defaultName: "PANTA MARKET",
    logoutWallet: "지갑 로그인 종료"
  },
  teamDetails: {
    myReferrals: "내 초대",
    currentLevel: "현재 등급: {level}",
    effectiveLevel: "현재 유효 등급: {level}",
    nextLevel: "다음 등급",
    nextLevelClosed: "아직 미개방",
    totalMembers: "직추 인원",
    activatedCount: "활성화 인원",
    validMembers: "유효 인원",
    teamLevel: "팀 등급: {level}",
    tradeTeam: "거래 팀",
    financeTeam: "펀드 팀",
    predictTeam: "예측 팀",
    teamMembers: "팀 멤버",
    teamData: "팀 데이터",
    teamEarningsJoule: "팀 수익",
    teamFlowJoule: "팀 총 거래량",
    teamPowerUsdt: "팀 총 거래량",
    teamTotalCount: "팀 인원",
    teamEarningsWithUnit: "팀 수익({unit})",
    teamVolumeWithUnit: "팀 총 거래량({unit})",
    teamActiveStakeWithUnit: "팀 현재 스테이킹({unit})",
    effectiveTradingCount: "거래 유효 인원",
    activeInvestorCount: "펀드 운용 인원",
    dividendEligibleCount: "배당 자격 활성 인원",
    myTeamReward: "팀 수익",
    teamPerformance: "팀 총 거래량",
    directMembers: "팀 멤버",
    filterAll: "전체",
    filterEffective: "업무 유효",
    filterDividend: "배당 달성",
    filterDirect: "직추",
    filterIndirect: "간추",
    addRemark: "메모 추가",
    editRemark: "메모 수정",
    saveRemark: "수정",
    remarkPlaceholder: "메모를 입력하세요",
    remarkSaved: "메모가 저장되었습니다",
    remarkFailed: "메모 저장 실패",
    myCurrentLevel: "현재 등급: {level}",
    personalTradePerf: "개인 거래 실적: {value}",
    personalStakePerf: "개인 스테이킹 실적: {value}",
    currentTotalPerf: "본인 업그레이드 실적: {value}",
    currentAreaPerf: "팀 업그레이드 실적: {value}",
    viewingIndirect: "{name}의 직추",
    includesAllLevels: "전체 계층 포함",
    inviteDetails: "초대 상세",
    startDate: "시작일",
    endDate: "종료일",
    dateTo: "～",
    status: "상태: ",
    statusActivated: "활성화됨",
    statusNotActivated: "미활성화",
    statusDividendActivated: "배당 자격 활성화됨",
    statusDividendNotActivated: "배당 자격 미활성화",
    statusValid: "활성화됨",
    statusInvalid: "미활성화",
    time: "바인딩 시간",
    bindTime: "바인딩 시간",
    level: "등급",
    tradeLevel: "거래 등급",
    fundLevel: "펀드 등급",
    inviteType: "초대 유형",
    viewTeam: "팀 상세",
    viewDetail: "상세 보기",
    noSubMembers: "아직 직추가 없습니다",
    directCount: "직추 인원",
    teamSize: "팀 인원",
    teamTotalPerf: "팀 총 실적",
    teamTotalStake: "팀 현재 스테이킹",
    personalTotalPerf: "개인 총 실적",
    personalTotalStake: "개인 현재 스테이킹",
    settledOrderCount: "누적 정산 주문 수",
    activeSubscriptionCount: "유효 운용 상품 수",
    eventContractParticipants: "누적 정산 주문 수",
    communityValidCount: "배당 달성: ",
    communityTotalPerf: "본인 실적: ",
    areaTotalPerf: "유효 스테이킹: ",
    yesterdayStake: "어제 신규 스테이킹: ",
    communityMaxLevel: "커뮤니티 최고 등급: ",
    personalEquity: "개인 권익금: ",
    peopleUnit: "{n}명",
    loadFailed: "불러오기 실패, 다시 시도하세요",
    forbidden: "이 팀을 볼 권한이 없습니다"
  },
  teamMemberModal: {
    totalProfit: "총 수익",
    totalFlow: "총 거래량",
    totalInvites: "총 초대 수",
    validMembers: "총 유효 멤버"
  },
  fundRecords: {
    feeLabel: "수수료: {fee}",
    withdrawTitle: "출금 기록",
    exchangeTitle: "환전 기록",
    depositTitle: "입금 기록",
    detailTitle: "기록 상세",
    statusLabel: "상태",
    amountLabel: "금액",
    claimHint: "신고 기록이며, 금액은 연관 송금 기준입니다",
    confirmProgress: "확인 수 {cur}/{req}",
    ledgerTitle: "연관 내역",
    ledgerEmpty: "연관 내역 없음",
    AUTHORIZED: "심사 완료, 온체인 실행 대기",
    BROADCASTING: "온체인 거래 전송됨, 확인 대기",
    CONFIRMED: "온체인 검증 완료, 입금 대기",
    CONFIRMING: "인식됨, 확인 대기",
    CREDITED: "입금 완료",
    EXPIRED: "승인 만료",
    MANUAL_REVIEW: "이상 재검토 중",
    PENDING: "처리 중",
    PENDING_CHAIN: "온체인 거래 대기",
    PENDING_REVIEW: "심사 대기",
    REJECTED: "검증 실패",
    REORGED: "체인 재구성, 재검토 대기",
    UNMATCHED: "송금 미일치",
    VERIFIED: "검증 완료",
  },
  aiAssistant: {
    title: "PANTA MARKET",
    newChat: "새 대화",
    manual: "운영 매뉴얼",
    manualCardTitle: "운영 매뉴얼 보기",
    manualCardDesc: "충전·교환·이체·AI 예측 전체 도해 단계",
    hello: "안녕하세요, AI 어시스턴트입니다",
    hint: "시세 분석, 이벤트/AI 보험 규칙 위치, 팀·초대 안내 또는 리스크를 물어보세요.",
    placeholder: "무엇을 물어볼까요...",
    send: "보내기",
    thinking: "분석 중...",
    disclaimer: "참고용이며 투자 권유가 아닙니다.",
    bullish: "상승",
    bearish: "하락",
    aiAnalysis: "AI 요약",
    strategy: "거래 전략",
    reasoning: "추론",
    targetPrice: "목표가 {price}",
    stopLoss: "손절 {price}",
    takeProfit: "익절 {price}",
    dirLong: "롱",
    dirShort: "숏",
    dirNeutral: "중립",
    analysisDone: "{symbol}({timeframe}) 분석을 마쳤습니다. 아래 카드를 확인하세요.",
    analysisBtc: "BTC 단기 분석입니다.",
    analysisEth: "ETH 횡보 분석입니다.",
    analysisRisk: "시장 리스크 해석입니다.",
    suggestions: {
      btc1m: "BTCUSDT 1분 단기 전망 분석",
      ethTrend: "ETH는 추격할까요, 관망할까요?",
      marketRisk: "현재 시장 리스크 선호도는?",
      eventRules: "이벤트 계약 보험 규칙 요약은 어디서 보나요?",
      aiRules: "AI 예측 규칙·등급은 어떻게 이해하나요?",
      teamWhere: "팀 세부 정보는 어디서 보나요?",
      inviteWhere: "초대 링크·상위 바인딩은 어디에 있나요?"
    },
    guides: {
      eventRules: "이벤트 계약 보험 규칙: 「이벤트 계약」거래 화면에서 보험 스위치 옆 규칙 진입점을 여세요. 「요약」에서 보험료·한도·보상/풀 요지, 「전체 약관」에서 정식 조항을 볼 수 있습니다.",
      aiRules: "AI 예측: 하단 중앙 → 「AI 예측」. 다음 라운드 카운트다운, 보험 등급/단계, 자율 예측 잔여 횟수를 확인하세요. 규칙은 같은 보험 규칙 시트의 AI 요약·전체 약관에 있습니다. 주문은 등급 금액·방향과 일치해야 합니다.",
      teamWhere: "팀 상세: 사이드바 또는 「내 정보」→「내 팀」. 거래/재테크 수익을 전환한 뒤 「팀 세부 정보」에서 직추·거래량·등급·멤버를 보고, 멤버를 눌러 직추 목록으로 내려갈 수 있습니다.",
      inviteWhere: "초대·바인딩: 사이드바/내 정보 →「친구 초대」에서 공유 링크(?ref=)를 복사하세요. 상위 미바인딩 시 로그인 후 「상위 바인딩」팝업이 뜨며, 초대 페이지에서도 입력할 수 있습니다. 초대 파라미터가 없으면 env의 기본 상위 주소가 미리 채워집니다."
    },
    generic: {
      a: "확인했습니다. 시세, 이벤트/AI 규칙 위치, 팀·초대를 묻거나 아래 바로가기를 눌러 보세요.",
      b: "알겠습니다. 방향 확률·전략 요점과 기능 안내를 드릴게요.",
      c: "이벤트 규칙, AI 규칙, 팀 상세, 초대 링크 바로가기를 시도해 보세요."
    }
  },
  createMarket: {
    title: "Create Market",
    saveDraft: "Save Draft",
    marketTitle: "Market Title",
    titlePlaceholder: "Enter market title",
    category: "Category",
    secondaryOptional: "Secondary (opt.)",
    deadline: "Deadline",
    optionsTitle: "Outcomes (2–16)",
    optionsSub: "Name each option",
    resetDefault: "Reset",
    addOption: "+ Add Option",
    ratioHint: "Initial ratio: leave blank to split evenly; if filled, each option needs an integer 1–99 and the total must be 100.",
    rulesSection: "Rules / Settlement Source",
    rulesSectionSub: "Optional — shown in the rules & settlement popup on the detail page",
    rulesLabel: "Rules",
    rulesPlaceholder: "Settlement criteria, edge cases, etc.",
    settleLabel: "Settlement Source",
    settlePlaceholder: "Official site / news / URL",
    liquidityTitle: "Initial Liquidity",
    liquiditySub: "Funds needed to bootstrap the market",
    enabled: "On",
    disabled: "Off",
    investAmount: "Amount (JOULE)",
    balance: "Balance: {n}",
    max: "Max",
    initialLiquidity: "Initial Liquidity",
    marginRefund: "Margin (refunded after settlement)",
    totalTip: "Margin matches liquidity 1:1 and is fully refunded when the event settles or is canceled.",
    totalDeduct: "Total Deduct",
    feeTip: "Tip: you earn a 0.5% creator fee on every trade in this market.",
    accessPassword: "Access Password",
    accessPasswordSub: "The event will show a lock. Only people with the share link or password can enter.",
    passwordPlaceholder: "Set password (4–20 chars)",
    hide: "Hide",
    show: "Show",
    cardPreview: "Card Preview",
    deadlinePrefix: "Ends {date}",
    submitting: "Creating...",
    submit: "Confirm & Add Liquidity",
    createSuccess: "Created",
    creating: "Creating",
    creatingDesc: "Please wait while we submit the market…",
    backHome: "Home",
    createAnother: "Create Another",
    deadlineShort: "{m}/{d}",
    yes: "Yes",
    no: "No",
    optionN: "Option {n}",
    draftSaved: "Draft saved",
    draftSaveFailed: "Failed to save draft",
    resetDone: "Reset to defaults",
    maxOptions: "Up to 16 options",
    minOptions: "Keep at least 2 options",
    needMinOptions: "Need at least 2 options",
    fillOptionName: "Enter a name for option {n}",
    fillAllPercents: "Fill a ratio for every option",
    percentRange: "Ratios must be integers 1–99",
    percentSum: "Ratios must sum to 100 (now {sum})",
    enterTitle: "Enter a market title",
    enterAmount: "Enter an amount",
    insufficientBalance: "Insufficient balance (incl. margin)",
    passwordLength: "Password must be 4–20 characters",
    deadlineFuture: "Deadline must be in the future",
    completeForm: "Please complete the form",
    createdMsg: "“{title}” created. Ends {date} {time}"
  },
  marketDetail: {
    tabTrades: "최근 체결",
    tabLp: "LP",
    tabPositions: "포지션",
    tabRules: "규칙",
    colAddress: "주소",
    colTime: "시간",
    colType: "유형",
    colVolumePrice: "체결량/체결가",
    colTurnover: "체결액",
    typeBuy: "매수",
    typeSell: "매도",
    empty: "데이터 없음",
    share: "공유",
    rulesBody: "본 시장은 이진 이벤트 예측입니다. 정산 전 호가가 잠길 수 있으며, 잠긴 후 결과 공시와 보유 지분에 따라 정산됩니다. 시장 위험에 유의하고 신중히 참여하세요.",
    priceJoule: "가격 (JOULE)",
    investJoule: "투입 (JOULE)",
    totalLiquidity: "총 유동성",
    dealPrice: "체결가",
    estProfit: "예상 수익",
    jouleBalance: "JOULE 잔액: {n}",
    positionCount: "포지션 수: {n}",
    max: "최대",
    confirmOrder: "주문 확인",
    ordering: "주문 중...",
    enterAmount: "투입 금액을 입력하세요",
    invalidPrice: "유효한 가격을 입력하세요",
    amountExceed: "투입이 가용 잔액을 초과합니다",
    orderSuccess: "주문 성공",
    poolSize: "풀 규모",
    colBalance: "잔액",
    shares: "{n}주",
    rulesTitle: "규칙 안내",
    rulesValue: "설명 없음",
    settleSource: "정산 출처",
    settleValue: "설명 없음"
  },
  rank: {
    applyTitle: "Become an Expert",
    applyDesc: "Show your trading talent and earn revenue share",
    applyCta: "Join Now",
    tabExpert: "Expert Ranking",
    tabMaker: "Market Maker",
    tabWinRate: "Win Rate",
    tabProfit: "Profit",
    experts: {
      trendCatcher: "Trend Catcher",
      whaleWatcher: "Whale Watcher",
      cryptoWolf: "Crypto Wolf",
      swingCaptain: "Swing Captain",
      arbHunter: "Arb Hunter",
      bullKnight: "Bull Knight"
    },
    tagPolitics: "Politics",
    tagEsports: "Esports",
    comingSoon: "Coming soon"
  },
  operationManual: {
    title: "운영 매뉴얼",
    docTitle: "PANTA MARKET 운영 매뉴얼",
    sourceHint: "공식 매뉴얼을 도해로 재구성했습니다. 스크린샷을 탭하면 확대됩니다."
  },
  pantaMarket: {
    title: "Panta Market",
    tokenSection: "PANTA 거버넌스 토큰",
    todayBurn: "오늘 소각",
    totalBurn: "누적 소각",
    burned: "소각됨",
    initialSupply: "초기 발행량",
    maxSupply: "최대 발행량",
    finalCirculation: "최종 유통량",
    contractAddress: "컨트랙트: ",
    copied: "복사됨",
    ecoSection: "PANTA · AI 앱 생태계",
    ecoTabs: {
      market: "시세 분석",
      arbitrage: "차익 도구",
      acquisition: "글로벌 확보",
      video: "영상 제작"
    },
    apps: {
      pantaAi: "Panta AI",
      asiStar: "ASI Star",
      tatianaTv: "Tatiana TV",
      tokenSpace: "Token space"
    },
    groupSection: "PANTA · 크리에이티브 공동구매",
    groupTabs: {
      recommend: "추천",
      hot: "인기",
      ipDrama: "IP 숏드라마",
      ipCollab: "IP 공동창작",
      data: "데이터"
    },
    filters: {
      all: "전체 추천",
      new: "신작 공개",
      ending: "종료 임박",
      highScore: "AI 고득점"
    },
    project: {
      badge: "플래닛 첫 공개",
      title: "《Panta AI · 라이즈》 AI 애니메이션 숏드라마",
      score: "AI 점수 92",
      tagDrama: "IP 숏드라마",
      tagRights: "권리확정#0001",
      desc: "Panta AI와 함께 역전하는 AI 앱 튜토리얼 숏드라마"
    },
    values: {
      todayBurn: "321개",
      totalBurn: "4212개",
      initialSupply: "1000만개",
      maxSupply: "2.1억개",
      finalCirculation: "2100만개"
    }
  },
  copyTrade: {
    menuTitle: "카피 트레이딩",
    pageTitle: "카피 트레이딩",
    fallback: "작업에 실패했습니다. 나중에 다시 시도하세요.",
    pauseRule:
      "이번 주 정산이 끝날 때 여전히 일시정지 상태이면, 다음 주에 팔로우 관계가 자동으로 해제됩니다.",
    pauseSuccess: "일시정지되었습니다",
    resumeSuccess: "재개되었습니다",
    endSuccess: "종료되었습니다",
    followSuccess: "카피를 시작했습니다",
    pendingReviewToast: "트레이더 심사 대기",
    savedSuccess: "저장되었습니다",
    registerSuccess: "등록 완료. 보증금이 동결되었습니다.",
    cancelRequested: "해지를 신청했습니다",
    cancelWithdrawn: "해지 신청을 철회했습니다",
    kickedSuccess: "제거되었습니다",
    approvedSuccess: "승인되었습니다",
    rejectedSuccess: "거절되었습니다",
    filledToForm: "팔로우 양식에 입력했습니다",
    traderNotFound: {
      search:
        "트레이더를 찾을 수 없습니다. 지갑 주소를 확인하거나, 상대가 아직 리드를 활성화하지 않았을 수 있습니다.",
      business: "이 트레이더는 현재 이용할 수 없습니다",
    },
    tabs: {
      board: "랭킹",
      follows: "내 팔로우",
      join: "팔로우",
      trader: "리드",
      apps: "신청",
      fans: "팔로워",
      rules: "규칙",
      settings: "규칙",
      follow: "팔로우",
    },
    ui: {
      refresh: "새로고침",
      search: "검색",
      loginWallet: "지갑 연결",
      needLoginAction: "이 작업에는 지갑 로그인이 필요합니다(주문과 동일).",
      needLoginTrader: "트레이더 관련 API는 로그인이 필요합니다.",
      loginToView: "로그인 후 확인",
      loading: "로딩 중…",
      empty: "없음",
      readonly: "읽기 전용",
      yes: "예",
      no: "아니오",
      immediate: "즉시 반영",
      current: "현재",
      nextWeek: "다음 주",
      pause: "일시정지",
      resume: "재개",
      end: "종료",
      save: "저장",
      kick: "제거",
      approve: "승인",
      reject: "거절",
      requestCancel: "신원 해지",
      withdrawCancel: "해지 철회",
      confirmFollow: "팔로우 확인",
      registerWithDeposit: "보증금 동결 후 등록",
      registerConfirmTitle: "등록 확인",
      registerFreezeConfirm: "거래 계좌에서 {amount} JOULE 보증금이 동결됩니다.",
      platformSettings: "플랫폼 설정",
      settingsTip:
        "복사 대상은 일반 모드이면서 보험이 켜진 리드 주문만입니다. 미보험 일반 주문과 AI 주문은 복사되지 않으며, 생성된 COPY 주문도 다시 리드하지 않습니다. 트레이더는 기존 주문 API를 사용하고 orderSource를 전달하지 마세요. 팔로워는 주문 목록에서 COPY 주문을 확인할 수 있습니다. 금액은 소수점 2자리까지 표시하고 이후는 버립니다.",
      deposit: "보증금",
      depositFreezeWeeks: "보증금 동결 주수",
      maxFollowers: "팔로워 상한",
      shareRateRange: "분배율 범위",
      shareRateDefault: "기본 분배율",
      shareRateNextWeek: "분배율은 다음 주 반영",
      pendingShareHint: "다음 주 월요일 적용: {rate}",
      pendingMaxFollowersHint: "다음 주 월요일 적용: {n}",
      depositFrozenShort: "동결 중",
      minFollowStake: "최소 팔로우 원금",
      ratioRange: "비율 범위",
      maxSimultaneousFollows: "동시 팔로우 상한",
      defaultReview: "기본 심사",
      defaultMinBalance: "기본 잔액 기준",
      settlementTimezone: "정산 타임존",
      leaderboardMeta: "랭킹 최소 건수 / 개수",
      leaderboardMetaValue: "{min}건 / {size}개",
      weekLeaderboard: "이번 주 승률 랭킹",
      expertLeaderboard: "트레이더 랭킹",
      heroTitle: "실력 트레이더 되기",
      heroDesc: "리드 거래를 시작하고 수익 배분을 받으세요",
      heroActiveTitle: "실력 트레이더가 되었습니다",
      heroActiveDesc: "리드 거래 신원이 활성화되어 있습니다",
      heroRegister: "트레이더 등록",
      heroSettings: "리드 설정",
      myLeading: "내 리드",
      winRateBoard: "승률 랭킹",
      pnlBoard: "수익 랭킹",
      searchAddress: "주소 검색",
      searchNicknameOrAddress: "닉네임 또는 주소 검색",
      searchQueryTooShort: "최소 2자 이상 입력하세요",
      winRateShort: "승률",
      followersLabel: "팔로워 수:",
      shareRateLabel: "분배율:",
      roundPnlLabel: "이번 라운드 손익:",
      settledOrders: "정산 {n}건",
      activeCount: "진행 중",
      followStatsShort: "풀 {pool} · 보류 {cash}",
      traderSettings: "리드 설정",
      confirmChanges: "변경 확인",
      confirmCancel: "해지 확인",
      cancelModalTitle: "해지 안내",
      activeInProgress: "진행 중",
      leadingFollowerCount: "팔로워 수 {n}",
      auditApps: "심사 신청 {n}",
      leaderboardNote:
        "이번 주·일반 소스·보험 적용된 승/패 정산 주문만 집계하며, 최소 건수를 충족한 트레이더만 노출됩니다. 전체 기간 승률이나 AI 승률이 아닙니다. 팀명과 누적 팔로우 금액은 제공되지 않습니다.",
      weekStart: "주 시작(월): {date}",
      leaderboardEmpty: "랭킹 트레이더가 없습니다. 전체 주소로 검색해 팔로우할 수 있습니다.",
      winRate: "승률 {n}%",
      boardSub:
        "분배 {share} · 팔로워 {followers}/{max} · 정산 {orders} · 주간 손익 {pnl} JOULE",
      searchTrader: "트레이더 검색",
      walletPlaceholder: "전체 지갑 주소 0x…",
      address: "주소",
      status: "상태",
      shareRate: "분배율",
      review: "심사",
      minBalance: "잔액 기준",
      followerCount: "팔로워",
      startFollow: "팔로우 시작",
      traderWallet: "트레이더 주소",
      followMode: "팔로우 방식",
      ratioLabel: "비율(%), 범위 {min} ~ {max}",
      insuranceMode: "보험 모드",
      takeProfit: "익절(JOULE, 선택)",
      stopLoss: "손절(JOULE, 선택)",
      takeProfitPh: "주간 순이익 도달 시 일시정지",
      stopLossPh: "주간 순손실 도달 시 일시정지",
      followHint:
        "동시에 팔로우할 수 있는 트레이더는 최대 {n}명입니다. 상한에 도달한 뒤 새로 팔로우하면 기존 관계가 먼저 종료됩니다(영향 없는 미리보기가 아님). 파라미터 변경은 종료 후 다시 팔로우하세요.",
      endConfirm:
        "해당 트레이더와의 카피 트레이딩 관계를 종료할까요? 종료 후에는 시그널을 더 이상 따르지 않습니다. 과거 주문 및 정산된 손익에는 영향이 없습니다.",
      weeklyPoolHint:
        "풀은 이번 주 분이며 누적 팔로우 금액이 아닙니다. 종료된 관계와 심사 대기 신청은 이 목록에 포함되지 않습니다.",
      networkUnclear:
        "결과를 확인할 수 없습니다. 새로고침 후 현재 관계 또는 트레이더 정보를 확인한 뒤 다시 시도하세요.",
      myFollows: "내 팔로우",
      noFollows: "팔로우 관계가 없습니다",
      followSub:
        "{mode}{ratio} · {insurance} · 잠금 분배 {share}",
      followStats:
        "주간 손익 {pnl} · 풀 {pool} · 보류 {cash}",
      pauseReason: "일시정지 사유: {reason}",
      registerTrader: "트레이더 등록",
      registerHint:
        "등록 조건: 리드 보증금으로 {amount} JOULE을 한 번에 납부합니다(활성 기간 동결, 해지 심사 후 반환). 지갑당 트레이더 신원은 1개만 가능합니다.",
      registerBalanceHint:
        "보증금 {deposit} JOULE 동결 후에도 사용 가능 잔액이 ≥ {remain} JOULE이어야 합니다.",
      shareRateInput:
        "분배율(%) 범위 {min} ~ {max}. 변경은 다음 주기부터 반영됩니다.",
      maxFollowersInput: "팔로워 상한(≤ {max})",
      reviewMode: "승인 방식",
      minBalanceInput: "팔로워 잔액 기준 · 선택(JOULE)",
      myTrader: "내 트레이더 정보",
      depositHeld: "{amount} / 동결 {held}",
      currentFollowers: "현재 팔로워 수",
      cancelEffective: "해지 효력 시점",
      depositRelease: "보증금 반환",
      editParams: "설정 수정",
      editHint:
        "분배율/인원 상한은 다음 주 반영, 심사와 잔액 기준은 즉시 반영. 정산 잠금은 일요일 22:00~월요일 01:00 전(SGT). 서버 시간을 따르고 월요일 0:00에 임의로 편집을 재개하지 마세요.",
      shareRatePercent: "분배율(%)",
      minBalanceJoule: "잔액 기준(JOULE)",
      cancelTip:
        "해지 후에도 이번 주는 리드를 유지하며, 다음 주 월요일 0:00에 신원이 종료됩니다. 보증금은 한 주 더 동결된 뒤 반환됩니다. 효력 전에는 철회할 수 있습니다.",
      followers: "팔로워",
      followerSub: "{mode}{ratio} · 주간 손익 {pnl} · 보류 {cash}",
      applications: "심사 대기 신청",
      noApplications: "신청이 없습니다",
      fillForm: "팔로우 양식에 입력",
      needTraderFirst: "먼저 트레이더로 등록하세요",
      cancelRequestedAt: "해지 신청 시각",
      ratioRangeInvalid: "비율은 {min} ~ {max} 사이여야 합니다",
      shareRangeInvalid: "분배율은 {min} ~ {max} 사이여야 합니다",
      maxFollowersInvalid: "팔로워 상한은 {max}를 초과할 수 없습니다",
      needShareRate: "분배율을 입력하세요",
      needMaxFollowers: "팔로워 상한을 입력하세요",
      needRatio: "비율을 입력하세요",
      badTakeProfit: "익절 금액이 올바르지 않습니다",
      badStopLoss: "손절 금액이 올바르지 않습니다",
      badMinBalance: "잔액 기준이 올바르지 않습니다",
      insuranceShortFollow: "추종",
      insuranceShortOn: "항상 켜기",
      insuranceShortOff: "항상 끄기",
      symbolSettings: "팔로우 종목 설정",
      symbolPickHint: "처음에는 모두 꺼져 있습니다. 직접 켜고 언제든 수정할 수 있습니다",
      followSymbolHint: "이 트레이더가 개방한 종목에서 선택하고 최소 1개를 켜세요.",
      followSymbolWait: "먼저 트레이더를 검색한 뒤 팔로우할 종목을 선택하세요.",
      symbolNeedOne: "최소 1개 종목을 켜세요",
      symbolNotAllowed: "선택한 종목은 이 트레이더가 허용하지 않습니다",
      effectiveSymbols: "유효",
      editSymbols: "종목 수정",
      allowedSymbols: "개방 종목",
      weekPnlLabel: "이번 주 손익:",
      currentNetPnlLabel: "현재 순손익",
      categoryCrypto: "암호화폐",
      categoryCommodity: "원자재",
      categoryEquity: "주식",
      symbolListCol: "목록",
      symbolLeadCol: "리드",
      symbolFollowCol: "팔로우",
      symbolTags: "개방",
      leadingSymbols: "리드 종목",
      detail: "상세",
      enabled: "켜짐",
      disabled: "꺼짐",
      held: "보유 중",
      notHeld: "미보유",
      weekSettledOrders: "이번 주 정산",
      historicalNetPnl: "누적 손익",
      copyTotalPnl: "카피 총손익",
      historicalSharePayout: "누적 분배 수령",
      allOrders: "전체",
      prevPage: "이전",
      nextPage: "다음",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "이동",
      jumpConfirm: "확인",
      openOrders: "진행 중",
      settledOrdersTab: "정산됨",
      colInterval: "기간",
      colOrderTime: "주문 시간",
      colSelfPnl: "본인 손익(보험료 포함)",
      colEstShare: "예상 분배(JOULE)",
      traderOrdersTitle: "{symbol} 리드 주문",
      followOrdersTitle: "{symbol} 카피 주문",
      selfPnl: "본인 손익",
      estimatedShare: "예상 분배",
      inProgress: "진행 중",
      followAssets: "자산별 손익",
      byAsset: "자산별",
      followHistory: "종료됨",
      followStartTime: "시작: ",
      followEndTime: "종료: ",
      myPendingApps: "심사 대기",
      cashHeldHint: "이번 주 예상 분배 보류 {cash} JOULE",
      cashHeldFrozen: "이번 라운드 예상 분배 공제: {cash}(JOULE, 동결)",
      followedTrader: "트레이더",
      followInfo: "팔로우 정보",
      totalPnlJoule: "총 손익(JOULE)",
      colTrader: "트레이더",
      colPrincipal: "원금",
      colPnlShare: "손익(보험료 포함)/분배(JOULE)",
      traderInfo: "트레이더 정보",
      traderNotFound: "트레이더를 찾을 수 없습니다",
      followSettingsRelationHint: "따라하기 방식·보험·익절/손절은 관계 전체에 적용되며, 선택한 모든 종목에 유효합니다. 「따라하기 설정」에서 언제든 수정할 수 있습니다.",
      followSettingsPrepareHint: "확인 후, 선택한 종목에 동일한 팔로우 설정을 적용해 시작합니다.",
      followOptions: "팔로우 옵션",
      noFollowOptions: "팔로우 옵션이 없습니다~",
      symbolFollowing: "팔로우 중",
      symbolPaused: "일시정지",
      symbolIdle: "미팔로우",
      cancelFollowSymbol: "팔로우 해제",
      cancelSymbolConfirm: "{symbol} 팔로우를 해제할까요?",
      cancelLastSymbolConfirm: "마지막 종목입니다. 해제하면 팔로우 관계 전체가 종료됩니다. 계속할까요?",
      followNow: "지금 팔로우",
      followAll: "팔로우",
      unfollowAll: "전체 해제",
      unfollowAllConfirm:
        "이 트레이더의 모든 종목 팔로우를 해제할까요? 팔로우 관계 전체가 종료됩니다.",
      followSettings: "팔로우 설정",
      goFollowSettings: "이동 ›",
      copyAccountBalance: "카피 계정：{amount} JOULE",
      orderFollowerCount: "해당 주문 팔로워 수",
      copyingStatus: "카피 중",
      roleStatusLeading: "리딩 중",
      roleStatusFollowing: "카피 중",
      roleStatusPaused: "카피 일시중지",
      copyOrderTag: "카피",
      copyOpenPositions: "카피 보유 포지션",
      copyInsuredOrdinary: "일반 보험 적용",
      copyUninsured: "미보험",
      addSymbolHint: "이 종목을 현재 팔로우에 추가합니다.",
      myRelationStatus: "내 팔로우",
      latestSettlements: "최근 정산",
      resumeRelationFirst: "관계가 전체 일시정지 상태입니다. 종목 조작 전에 '내 팔로우'에서 재개하세요.",
      resumeStopLossHint: "Current weekly loss is {amount}. Set stop-loss above {amount} to resume copying.",
      resumeTakeProfitHint: "Current weekly profit is {amount}. Set take-profit above {amount} to resume copying.",
      resumeStartFollow: "Start following",
      colType: "유형",
      colPnlJoule: "손익(JOULE)",
      tpSl: "익절/손절",
      takeProfitPhFull: "주간 순이익 도달 후 일시정지 — 선택(JOULE)",
      stopLossPhFull: "주간 순손실 도달 후 일시정지 — 선택(JOULE)",
      confirmModify: "변경 확인",
      clearSearch: "랭킹으로 돌아가기",
      searchResultHint: "검색 결과(탭하여 트레이더 정보 열기)",
      searchEmpty: "트레이더를 찾을 수 없습니다",
      noMoreSettlements: "더 이상 없음",
    },
    errors: {
      AUTH_REQUIRED: "먼저 지갑을 연결하세요",
      AUTH_UNAVAILABLE: "로그인 서비스를 일시적으로 사용할 수 없습니다. 나중에 다시 시도하세요.",
      POSTGRES_REQUIRED: "서비스를 일시적으로 사용할 수 없습니다. 나중에 다시 시도하세요.",
      USER_NOT_FOUND: "사용자를 찾을 수 없습니다. 다시 로그인한 뒤 시도하세요.",
      INVALID_WALLET: "전체 지갑 주소를 입력하세요",
      INVALID_QUERY: "검색어가 올바르지 않습니다. 최소 2자 이상 입력하세요",
      INVALID_AMOUNT: "금액 형식이 올바르지 않습니다",
      INVALID_PARAM: "파라미터가 올바르지 않습니다. 확인 후 다시 시도하세요.",
      INVALID_FOLLOW: "자신의 거래는 팔로우할 수 없습니다",
      TRADER_EXISTS: "이 지갑은 이미 트레이더입니다. 다시 등록할 필요가 없습니다.",
      TRADER_FULL: "이 트레이더는 팔로워 상한에 도달했습니다",
      TRADER_CANCELLED: "이 트레이더 계정은 해지되었습니다",
      TRADER_REGISTER_FAILED: "트레이더 등록에 실패했습니다. 나중에 다시 시도하세요.",
      TRADER_SETTINGS_FAILED: "트레이더 설정 저장에 실패했습니다. 나중에 다시 시도하세요.",
      NOT_A_TRADER: "Register as a trader first",
      TRADER_UNAVAILABLE: "This trader is currently unavailable",
      INSUFFICIENT_BALANCE: "사용 가능 잔액이 부족하여 보증금을 동결할 수 없습니다",
      BALANCE_TOO_LOW: "카피 계정 사용 가능 잔액이 이 트레이더 기준보다 낮습니다. 거래 계정에서 이체하세요",
      COPY_BALANCE_ZERO: "카피 계정 잔액이 0입니다. 거래 계정에서 이체하세요",
      INSUFFICIENT_FUNDS: "거래 계정 잔액이 부족하여 카피 계정으로 이체할 수 없습니다",
      COPY_TRADE_BALANCE_INSUFFICIENT: "카피 계정 사용 가능 잔액 부족(동결 원금/분배는 출금 불가)",
      ACCOUNT_NOT_FOUND: "계정 오류입니다. 나중에 다시 시도하세요.",
      ACCOUNT_CONFLICT: "계정이 업데이트 중입니다. 나중에 다시 시도하세요.",
      FOLLOW_EXISTS: "이미 이 트레이더를 팔로우 중입니다",
      FOLLOW_LIMIT:
        "진행 중인 팔로우 관계가 있습니다. 다른 트레이더를 팔로우하기 전에 종료하세요.",
      FOLLOW_FAILED: "팔로우 시작에 실패했습니다. 나중에 다시 시도하세요.",
      FOLLOW_NOT_FOUND: "팔로우 관계를 찾을 수 없습니다",
      PAUSE_FAILED: "팔로우 일시정지에 실패했습니다. 나중에 다시 시도하세요.",
      RESUME_FAILED: "팔로우 재개에 실패했습니다. 나중에 다시 시도하세요.",
      STOP_LOSS_THRESHOLD: "Stop-loss is still too low. Raise or clear it, then resume.",
      TAKE_PROFIT_THRESHOLD: "Take-profit is still too low. Raise or clear it, then resume.",
      END_FAILED: "팔로우 종료에 실패했습니다. 나중에 다시 시도하세요.",
      APPLICATION_NOT_FOUND: "심사 대기 신청을 찾을 수 없습니다",
      APPROVE_FAILED: "신청 승인에 실패했습니다. 나중에 다시 시도하세요.",
      REJECT_FAILED: "신청 거절에 실패했습니다. 나중에 다시 시도하세요.",
      KICK_FAILED: "팔로워 제거에 실패했습니다. 나중에 다시 시도하세요.",
      SETTLEMENT_WINDOW: "정산 창 동안에는 트레이더 설정을 변경할 수 없습니다",
      CANCEL_FAILED: "해지 신청에 실패했습니다. 나중에 다시 시도하세요.",
      CANCEL_NOT_PENDING: "철회할 해지 신청이 없습니다",
      CANCEL_WITHDRAW_FAILED: "해지 철회에 실패했습니다. 나중에 다시 시도하세요.",
      COPY_SETTINGS_MISSING: "카피 트레이딩 설정이 준비되지 않았습니다. 나중에 다시 시도하세요.",
      INVALID_SYMBOL: "지원 종목을 최소 1개 선택하세요",
      SYMBOL_NOT_ALLOWED: "이 트레이더가 허용하지 않는 종목이 포함되어 있습니다",
      TRADER_BALANCE_TOO_LOW: "보증금 동결 후 사용 가능 잔액이 부족하여 등록할 수 없습니다",
      TIMEOUT: "작업에 실패했습니다. 나중에 다시 시도하세요.",
      NETWORK: "작업에 실패했습니다. 나중에 다시 시도하세요.",
    },
    status: {
      ACTIVE: "팔로우 중",
      PAUSED: "일시정지",
      ENDED: "종료됨",
      PENDING_REVIEW: "트레이더 심사 대기",
      CANCEL_PENDING: "해지 중",
      CANCELLED: "해지됨",
    },
    traderStatus: {
      ACTIVE: "리딩 중",
      CANCEL_PENDING: "종료 중",
      CANCELLED: "취소됨",
    },
    pauseReason: {
      USER: "사용자 일시정지",
      INSUFFICIENT_BALANCE: "카피 계정 잔액 부족으로 일시정지",
      TAKE_PROFIT: "익절 트리거",
      STOP_LOSS: "손절 트리거",
      TRADER_KICK: "트레이더에 의해 제거",
      SWITCH: "트레이더 전환",
      SETTLEMENT_CLEANUP: "주간 정산으로 제거",
      TRADER_CANCEL: "트레이더 해지",
    },
    followMode: {
      EQUAL: "동일 금액",
      RATIO: "비율",
    },
    insuranceMode: {
      FOLLOW: "트레이더 추종",
      ALWAYS_ON: "항상 켜기",
      ALWAYS_OFF: "항상 끄기",
    },
    reviewMode: {
      AUTO: "자동 승인",
      MANUAL: "수동 심사",
    },
    applicationStatus: {
      PENDING: "심사 대기",
      APPROVED: "승인됨",
      REJECTED: "거절됨",
      CANCELLED: "취소됨",
      PENDING_REVIEW: "심사 대기",
    },
  },}
